export const compare_icon = [
  {
    icon: (
      <svg
        width="547"
        height="380"
        viewBox="0 0 547 380"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_361_258)">
          <path
            d="M520.737 327.156V380H441.209L456.704 298.852C456.208 302.056 466.127 308.063 479.699 314.085C484.57 316.248 490.003 318.394 495.803 320.429C505.161 323.728 513.782 325.971 520.737 327.156Z"
            fill="#9A3B82"
          />
          <path
            d="M520.737 311.266V325.41C513.782 324.225 505.177 321.998 495.787 318.698C473.658 310.93 456.624 301.335 457.586 297.026C457.602 296.962 457.618 296.898 457.634 296.85C459.124 292.637 478.721 295.552 501.155 303.417C508.366 305.948 514.872 308.559 520.336 311.074C520.464 311.138 520.593 311.202 520.737 311.266Z"
            fill="#06D6A0"
          />
          <path
            d="M509.824 188.823C502.068 188.823 495.787 195.102 495.787 202.839V241.25C495.787 248.987 489.505 255.266 481.765 255.266H425.553C433.308 255.266 439.574 248.987 439.574 241.25V202.839C439.574 195.086 445.855 188.823 453.595 188.823H509.824Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.243 208.701H449.445V241.907H485.243V208.701Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.227 213.442H449.445"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.227 218.184H449.445"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.227 222.941H449.445"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.227 227.683H449.445"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.227 232.44H449.445"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M485.227 237.182H449.445"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M495.787 202.839C495.787 195.134 502.004 188.887 509.68 188.823C517.372 188.887 523.573 195.134 523.573 202.839H495.787Z"
            fill="#3A86FF"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M481.83 255.619C481.814 255.619 481.782 255.619 481.766 255.619H425.762C425.729 255.619 425.697 255.619 425.665 255.619C419.913 255.538 414.993 251.982 412.91 246.953H469.027C471.126 251.982 476.045 255.538 481.83 255.619Z"
            fill="#06D6A0"
          />
          <path
            d="M451.784 204.889H445.311V199.699H448.355V202.582C448.355 202.647 448.387 202.695 448.419 202.711L448.435 202.727L451.784 204.889Z"
            fill="#FE5244"
          />
          <path
            d="M454.3 201.493V202.182C454.3 202.31 454.284 202.438 454.284 202.566C454.284 202.598 454.268 202.646 454.268 202.678C454.252 202.742 454.252 202.807 454.236 202.871C454.06 203.752 453.531 204.472 452.874 204.745C452.826 204.761 452.778 204.777 452.73 204.793C452.65 204.825 452.554 204.841 452.474 204.857C452.442 204.857 452.41 204.873 452.378 204.873L448.708 202.486C448.74 201.926 449.093 201.477 449.509 201.477H454.3V201.493Z"
            fill="#FE5244"
          />
          <path
            d="M490.05 199.699V204.889H483.576L486.909 202.727L486.925 202.711C486.941 202.695 486.941 202.695 486.957 202.695C486.957 202.679 486.973 202.679 486.973 202.663C486.973 202.663 486.973 202.647 486.989 202.647C486.989 202.631 486.989 202.631 487.005 202.631C487.005 202.631 487.005 202.631 487.005 202.615C487.005 202.599 487.005 202.599 487.005 202.582V199.699H490.05Z"
            fill="#FE5244"
          />
          <path
            d="M486.685 202.502L483.016 204.889C482.92 204.873 482.823 204.857 482.727 204.841C482.695 204.825 482.663 204.825 482.631 204.809C482.583 204.793 482.551 204.777 482.503 204.761C482.471 204.745 482.423 204.729 482.391 204.713C481.894 204.441 481.477 203.912 481.269 203.255C481.237 203.159 481.205 203.063 481.189 202.967C481.173 202.935 481.173 202.887 481.157 202.839C481.125 202.63 481.093 202.422 481.093 202.198V201.509H485.9C486.301 201.493 486.653 201.942 486.685 202.502Z"
            fill="#FE5244"
          />
          <path
            d="M486.685 197.072V201.589C486.653 201.557 486.621 201.509 486.588 201.477C486.524 201.413 486.46 201.365 486.396 201.317C486.236 201.221 486.06 201.157 485.883 201.157H449.493C449.3 201.157 449.124 201.221 448.98 201.317C448.916 201.365 448.852 201.413 448.788 201.477C448.755 201.509 448.723 201.541 448.691 201.589V197.072C448.691 196.463 449.044 195.983 449.493 195.983H485.883C486.316 195.983 486.685 196.479 486.685 197.072Z"
            fill="#FE5244"
          />
          <path
            d="M520.737 262.619V325.41H520.721C513.766 324.225 505.161 321.998 495.771 318.698C489.97 316.664 484.538 314.502 479.667 312.355L482.279 297.779L486.718 273.03C472.793 268.673 470.533 255.282 470.533 255.282H481.734C489.49 255.282 495.755 249.003 495.755 241.266V236.653H488.56C483.513 236.653 479.411 231.687 479.411 226.642V225.008H495.403C498.367 225.008 501.155 226.401 502.934 228.772L514.632 244.39C518.606 249.644 520.737 256.035 520.737 262.619Z"
            fill="#A0505A"
          />
          <path
            d="M520.737 311.266V325.41H520.721C513.766 324.224 505.161 321.998 495.771 318.698C489.971 316.664 484.538 314.501 479.667 312.355L482.279 297.778C488.048 299.188 494.457 301.094 501.123 303.433C508.334 305.964 514.84 308.575 520.288 311.089C520.464 311.138 520.593 311.202 520.737 311.266Z"
            fill="#73325A"
          />
          <path
            d="M496.493 236.653H488.769C483.721 236.653 479.619 231.687 479.619 226.642V225.008H496.493V236.653Z"
            fill="#A0505A"
          />
          <path
            d="M491.637 252.255C491.637 252.255 502.773 256.436 503.783 270.804"
            stroke="#73325A"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M486.75 273.367H494.329"
            stroke="#73325A"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M479.683 93.7709L484.762 90.407C491.38 86.0341 500.242 90.359 500.867 98.256L501.972 112.24C502.581 119.913 511.026 124.286 517.644 120.361L520.849 118.455"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M405.859 41.8237L471.126 79.6908L503.991 153.455L466.286 128.066L425.313 80.0752L405.859 41.8237Z"
            fill="#9A3B82"
          />
          <path
            d="M406.035 39.2769L472.68 77.9608L506.25 153.278"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M465.602 129.696C468.652 127.122 461.798 113.994 450.294 100.373C438.791 86.7524 426.993 77.7971 423.943 80.3709C420.893 82.9447 427.747 96.0731 439.25 109.694C450.754 123.315 462.552 132.27 465.602 129.696Z"
            fill="white"
          />
          <path
            d="M463.755 130.479C466.744 127.957 460.021 115.084 448.74 101.726C437.459 88.3692 425.891 79.5859 422.902 82.1084C419.913 84.6309 426.635 97.5039 437.916 110.861C449.198 124.218 460.766 133.001 463.755 130.479Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M471.702 124.51L465.485 129.748C466.639 128.77 466.382 126.304 464.988 122.86C462.697 117.189 457.329 108.908 450.182 100.418C443.019 91.9446 435.744 85.265 430.536 82.0614C427.38 80.1071 424.976 79.4344 423.822 80.4115L430.04 75.1735C433.084 72.5946 445.423 81.0202 456.928 94.6517C468.433 108.283 474.763 121.947 471.702 124.51Z"
            fill="#06D6A0"
          />
          <path
            d="M538.122 104.471C539.885 103.622 541.6 102.869 543.25 102.245C544.228 103.27 545.077 104.471 545.734 105.817C546.391 107.162 546.807 108.572 547 109.965C545.477 110.862 543.827 111.759 542.08 112.608C533.315 116.853 525.335 118.471 524.246 116.229C523.14 113.97 529.357 108.716 538.122 104.471Z"
            fill="#06D6A0"
          />
          <path
            d="M522.643 119.272C523.714 119.272 524.582 118.404 524.582 117.334C524.582 116.263 523.714 115.396 522.643 115.396C521.572 115.396 520.704 116.263 520.704 117.334C520.704 118.404 521.572 119.272 522.643 119.272Z"
            stroke="#9A3B82"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M408.215 312.179V380H330.931L340.834 306.348C340.834 309.328 355.912 313.044 374.516 314.646C393.12 316.263 408.215 315.158 408.215 312.179Z"
            fill="#3A86FF"
          />
          <path
            d="M407.863 310.433C407.863 313.412 392.912 314.518 374.485 312.9C356.057 311.282 341.106 307.566 341.106 304.602C341.106 301.623 356.057 300.518 374.485 302.135C392.929 303.737 407.863 307.454 407.863 310.433Z"
            fill="#3FB1B5"
          />
          <path
            d="M418.583 160.086L423.262 163.113C427.941 166.733 421.467 182.912 408.808 199.218C396.149 215.541 382.096 225.825 377.417 222.205L375.109 220.026"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M353.604 236.076L406.725 187.477L425.297 130.949L368.603 182.447L353.604 236.076Z"
            fill="#3A86FF"
          />
          <path
            d="M350.896 241.971L408.712 189.079L427.572 131.653"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M381.471 187.317L331.027 235.548C328.575 237.886 324.569 235.676 325.258 232.344L326.668 225.504C327.309 222.413 323.8 220.154 321.252 222.012L304.587 234.138"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M291.014 251.406C289.524 252.655 288.034 253.808 286.592 254.817C285.39 254.065 284.284 253.12 283.307 251.966C282.345 250.813 281.592 249.564 281.063 248.25C282.313 247.001 283.691 245.735 285.182 244.47C292.633 238.207 299.972 234.667 301.59 236.589C303.193 238.511 298.466 245.142 291.014 251.406Z"
            fill="#06D6A0"
          />
          <path
            d="M303.033 237.246C304.104 237.246 304.972 236.378 304.972 235.307C304.972 234.237 304.104 233.369 303.033 233.369C301.962 233.369 301.094 234.237 301.094 235.307C301.094 236.378 301.962 237.246 303.033 237.246Z"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M383.858 261.129V313.508C380.893 313.38 377.737 313.188 374.484 312.9C362.482 311.858 351.97 309.904 346.089 307.854L346.97 302.055L349.919 282.593H346.105C340.673 282.593 336.282 278.204 336.282 272.774V253.488C336.282 249.676 337.66 246.008 340.176 243.14L352.723 228.804C353.54 227.875 355.079 228.452 355.079 229.685V249.179C355.079 251.518 354.245 253.776 352.723 255.554L351.601 256.868H365.222C367.193 256.868 368.347 254.673 367.241 253.04C365.558 250.589 363.347 247.097 361.248 243.06C357.066 235.067 364.324 230.598 364.324 230.598L380.941 252.143C382.832 254.754 383.858 257.909 383.858 261.129Z"
            fill="#06D6A0"
          />
          <path
            d="M355.079 228.644V249.179C355.079 251.518 354.246 253.777 352.723 255.555L351.602 256.868"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M351.601 256.852L342.596 266.96"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M355.078 240.257C355.078 242.596 354.245 244.855 352.723 246.633L351.601 247.946L342.611 258.038"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M355.078 231.351C355.078 233.69 354.245 235.948 352.723 237.726L351.601 239.04L342.611 249.131"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M349.919 283.122H356.825"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M383.858 303.16V313.508C380.893 313.38 377.737 313.188 374.484 312.899C362.482 311.858 351.97 309.904 346.089 307.854L346.97 302.055C352.995 301.174 363.074 301.126 374.5 302.119C377.737 302.423 380.877 302.76 383.858 303.16Z"
            fill="#FE5244"
          />
          <path
            d="M306.301 380H216.935V291.435C216.935 295.215 231.629 298.275 249.768 298.275C267.907 298.275 282.601 295.215 282.601 291.435V291.419L306.301 380Z"
            fill="#3FB1B5"
          />
          <path
            d="M282.361 289.673C282.361 293.469 267.827 296.529 249.88 296.529C231.933 296.529 217.399 293.469 217.399 289.689V289.673C217.447 285.909 231.965 282.849 249.88 282.849C267.795 282.849 282.329 285.909 282.361 289.673Z"
            fill="#3A86FF"
          />
          <path
            d="M282.361 289.737C282.249 293.485 267.747 296.529 249.88 296.529C246.435 296.529 243.134 296.417 240.026 296.208V263.259H223.072C220.909 263.259 219.162 261.513 219.162 259.35V256.707C219.162 255.522 219.691 254.465 220.524 253.744C219.691 253.023 219.162 251.966 219.162 250.781V248.138C219.162 247.097 219.579 246.135 220.252 245.447C219.579 244.742 219.162 243.797 219.162 242.756V240.113C219.162 239.039 219.595 238.062 220.3 237.341C219.595 236.637 219.162 235.66 219.162 234.586V229.797C219.162 227.634 220.909 225.888 223.072 225.888H244.721C245.442 225.472 246.611 223.998 244.624 223.133L239.977 222.044C236.292 220.202 233.952 217.142 233.952 213.01H250.297C253.037 213.01 255.489 214.74 256.418 217.319L281.961 288.6L282.361 289.737Z"
            fill="#E57281"
          />
          <path
            d="M282.441 289.769C282.393 289.721 282.361 289.689 282.361 289.689C282.361 293.469 267.827 296.529 249.88 296.529C246.435 296.529 243.134 296.417 240.025 296.208V283.186C243.134 282.977 246.451 282.865 249.88 282.865C266.065 282.865 279.493 285.364 281.961 288.616C282.025 288.696 282.201 289.128 282.441 289.769Z"
            fill="#9A3B82"
          />
          <path
            d="M245.089 181.358V194.349C245.089 201.413 239.369 207.131 232.302 207.131C225.235 207.131 219.515 201.413 219.515 194.349V181.358C219.515 184.53 225.235 187.092 232.302 187.092C239.369 187.092 245.089 184.53 245.089 181.358Z"
            fill="white"
          />
          <path
            d="M232.302 187.093C239.364 187.093 245.089 184.525 245.089 181.358C245.089 178.191 239.364 175.624 232.302 175.624C225.24 175.624 219.515 178.191 219.515 181.358C219.515 184.525 225.24 187.093 232.302 187.093Z"
            fill="#06D6A0"
          />
          <path
            d="M245.089 159.157V194.333C245.089 199.074 242.509 203.207 238.68 205.417C238.68 205.417 238.68 205.417 238.663 205.417C236.789 206.491 234.609 207.115 232.302 207.115C229.994 207.115 227.831 206.507 225.956 205.433C225.94 205.433 225.94 205.417 225.924 205.417C222.095 203.207 219.515 199.074 219.515 194.333V159.157H245.089Z"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M232.302 164.891C239.443 164.891 245.233 162.324 245.233 159.157C245.233 155.99 239.443 153.422 232.302 153.422C225.16 153.422 219.37 155.99 219.37 159.157C219.37 162.324 225.16 164.891 232.302 164.891Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M232.302 160.022C233.346 160.022 234.193 159.175 234.193 158.131C234.193 157.087 233.346 156.241 232.302 156.241C231.258 156.241 230.411 157.087 230.411 158.131C230.411 159.175 231.258 160.022 232.302 160.022Z"
            fill="#06D6A0"
          />
          <path
            d="M228.135 198.626C229.056 198.626 229.802 197.88 229.802 196.96C229.802 196.04 229.056 195.294 228.135 195.294C227.215 195.294 226.469 196.04 226.469 196.96C226.469 197.88 227.215 198.626 228.135 198.626Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M238.134 182.736C238.895 182.736 239.512 182.119 239.512 181.358C239.512 180.597 238.895 179.98 238.134 179.98C237.373 179.98 236.756 180.597 236.756 181.358C236.756 182.119 237.373 182.736 238.134 182.736Z"
            fill="white"
          />
          <path
            d="M224.802 193.067C225.563 193.067 226.18 192.45 226.18 191.69C226.18 190.929 225.563 190.312 224.802 190.312C224.041 190.312 223.424 190.929 223.424 191.69C223.424 192.45 224.041 193.067 224.802 193.067Z"
            fill="#06D6A0"
          />
          <path
            d="M244.592 272.229H220.011C219.562 272.229 219.434 271.637 219.819 271.429L228.407 268.177C229.754 267.664 230.651 266.367 230.651 264.925V213.731C230.651 210.335 228.888 207.147 225.956 205.433C227.831 206.507 229.994 207.115 232.301 207.115C234.625 207.115 236.788 206.491 238.663 205.417C235.714 207.115 233.952 210.319 233.952 213.715V264.909C233.952 266.351 234.849 267.648 236.195 268.161L244.784 271.413C245.169 271.637 245.041 272.229 244.592 272.229Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M223.2 139.919C224.403 139.919 225.379 138.944 225.379 137.74C225.379 136.537 224.403 135.562 223.2 135.562C221.996 135.562 221.021 136.537 221.021 137.74C221.021 138.944 221.996 139.919 223.2 139.919Z"
            fill="#06D6A0"
          />
          <path
            d="M238.134 143.427C239.178 143.427 240.025 142.581 240.025 141.537C240.025 140.493 239.178 139.646 238.134 139.646C237.09 139.646 236.243 140.493 236.243 141.537C236.243 142.581 237.09 143.427 238.134 143.427Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M228.872 150.795C229.633 150.795 230.25 150.178 230.25 149.418C230.25 148.657 229.633 148.04 228.872 148.04C228.111 148.04 227.494 148.657 227.494 149.418C227.494 150.178 228.111 150.795 228.872 150.795Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M228.151 134.024C228.78 134.024 229.289 133.515 229.289 132.887C229.289 132.259 228.78 131.75 228.151 131.75C227.523 131.75 227.014 132.259 227.014 132.887C227.014 133.515 227.523 134.024 228.151 134.024Z"
            fill="#06D6A0"
          />
          <path
            d="M248.775 231.031V263.275H223.072C220.909 263.275 219.162 261.529 219.162 259.367V256.724C219.162 255.539 219.691 254.481 220.524 253.761C219.691 253.04 219.162 251.983 219.162 250.797V248.154C219.162 247.113 219.579 246.152 220.252 245.463C219.579 244.758 219.162 243.813 219.162 242.772V240.129C219.162 239.056 219.595 238.079 220.3 237.358C219.595 236.653 219.162 235.676 219.162 234.603V231.047L248.775 231.031Z"
            fill="#E57281"
          />
          <path
            d="M219.61 250.573C219.61 253.024 221.597 255.01 224.049 255.01H244.848C247.3 255.01 249.287 253.024 249.287 250.573"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M219.61 242.58C219.61 245.03 221.597 247.017 224.049 247.017H244.848C247.3 247.017 249.287 245.03 249.287 242.58"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M219.61 234.586C219.61 237.037 221.597 239.023 224.049 239.023H244.848C247.3 239.023 249.287 237.037 249.287 234.586"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M223.841 263.003H244.848C247.3 263.003 249.287 261.017 249.287 258.566V228.596"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M229.642 228.468H227.51C226.805 228.468 226.229 229.044 226.229 229.749C226.229 230.454 226.805 231.031 227.51 231.031H239.432C240.714 231.031 241.772 229.989 241.772 228.692C241.772 227.154 243.022 225.905 244.56 225.905H246.499C248.037 225.905 249.287 227.154 249.287 228.692V233.882"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M375.141 63.3838L321.797 118.07L260.296 50.2969L327.421 3.0752L375.141 63.3838Z"
            fill="#3FB1B5"
          />
          <path
            d="M319.714 120.697L255.185 49.9928L325.947 0.400391"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M320.755 60.5648L324.777 59.9722C331.395 58.995 337.532 63.5763 338.51 70.1758L342.019 94.0749C343.205 102.132 351.858 106.745 359.213 103.221L375.99 95.1962"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M397.383 99.7773C399.097 100.706 400.716 101.667 402.19 102.628C401.934 104.022 401.453 105.4 400.748 106.729C400.043 108.043 399.145 109.212 398.12 110.189C396.501 109.484 394.803 108.667 393.088 107.738C384.515 103.109 378.538 97.5828 379.724 95.3883C380.91 93.1938 388.81 95.148 397.383 99.7773Z"
            fill="#06D6A0"
          />
          <path
            d="M377.898 96.686C378.969 96.686 379.837 95.8182 379.837 94.7478C379.837 93.6773 378.969 92.8096 377.898 92.8096C376.827 92.8096 375.959 93.6773 375.959 94.7478C375.959 95.8182 376.827 96.686 377.898 96.686Z"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M187.243 319.996V380H117.874V344.648C119.38 348.588 137.039 346.073 155.883 338.865C172.837 332.378 185.929 324.401 187.243 319.996Z"
            fill="#FE5244"
          />
          <path
            d="M187.243 318.25C185.913 322.655 172.837 330.632 155.867 337.119C137.039 344.328 119.38 346.842 117.858 342.902C116.336 338.961 131.559 330.039 150.403 322.831C169.231 315.623 185.736 312.98 187.243 316.92C187.403 317.321 187.403 317.769 187.243 318.25Z"
            fill="#3A86FF"
          />
          <path
            d="M172.548 278.461V329.303L168.718 331.241C164.841 333.131 160.498 335.005 155.883 336.767C147.406 340.019 139.154 342.309 132.52 343.495L136.334 328.518L142.551 304.074C139.603 304.074 136.814 302.76 134.94 300.486L109.413 271.461C113.788 267.472 120.326 272.902 120.326 272.902L117.874 260.392C117.297 257.429 118.162 254.353 120.197 252.127L127.953 243.621C129.491 241.939 132.264 242.596 132.904 244.774L138.417 263.788C138.417 263.788 152.101 274.232 154.665 274.232C157.566 274.232 158.575 271.877 153.159 264.14C149.089 258.326 153.159 254.081 153.159 254.081L166.411 265.23C170.305 268.529 172.548 273.367 172.548 278.461Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M143.336 275.497L133.642 267.744L128.338 249.452C127.729 247.353 125.149 246.729 123.675 248.346"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M136.991 278.909L128.562 272.053L123.547 254.738C122.97 252.751 120.438 252.159 119.044 253.697"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M129.539 280.655L120.31 272.918"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M142.552 304.074H153.336"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M172.549 316.2V329.639C167.773 332.17 162.085 334.733 155.884 337.12C147.391 340.371 139.138 342.662 132.488 343.847L136.334 328.854C140.596 326.804 145.372 324.753 150.419 322.831C158.576 319.724 166.299 317.449 172.549 316.2Z"
            fill="#06D6A0"
          />
          <path
            d="M161.684 146.951L166.555 157.635C167.02 161.592 164.199 165.164 160.242 165.644C156.284 166.109 153.463 169.697 153.928 173.654L154.633 179.58"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M218.057 112.624L243.727 72.5783L155.434 71.8735L126.511 148.857L174.263 146.615L218.057 112.624Z"
            fill="#FE5244"
          />
          <path
            d="M244.785 69.5671L152.47 68.5259L121.815 149.322"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M216.47 106.617C221.597 115.411 212.88 130.052 196.984 139.311C181.088 148.569 164.055 148.937 158.927 140.143C158.222 138.942 157.789 137.645 157.581 136.251C156.299 127.457 164.68 115.443 178.412 107.45C192.145 99.4572 206.727 98.0796 213.746 103.526C214.851 104.391 215.765 105.416 216.47 106.617Z"
            fill="#3A86FF"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M212.4 99.6332L216.47 106.617C215.765 105.416 214.852 104.391 213.746 103.526C206.728 98.0795 192.146 99.457 178.413 107.45C164.68 115.443 156.316 127.457 157.582 136.251C157.774 137.644 158.223 138.942 158.928 140.143L154.858 133.159C149.73 124.365 158.447 109.725 174.343 100.466C190.223 91.2237 207.272 90.8392 212.4 99.6332Z"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M153.255 201.173C152.63 203.015 151.957 204.777 151.252 206.394C149.825 206.378 148.383 206.138 146.973 205.658C145.547 205.177 144.265 204.504 143.111 203.655C143.528 201.941 144.041 200.131 144.666 198.289C147.774 189.063 152.197 182.239 154.569 183.024C156.94 183.825 156.347 191.946 153.255 201.173Z"
            fill="#06D6A0"
          />
          <path
            d="M154.889 183.056C155.96 183.056 156.828 182.188 156.828 181.118C156.828 180.047 155.96 179.18 154.889 179.18C153.818 179.18 152.95 180.047 152.95 181.118C152.95 182.188 153.818 183.056 154.889 183.056Z"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M72.1568 314.438V380H0.112305V283.506C1.52243 288.232 16.6011 298.083 35.3173 306.316C55.2353 315.11 71.7402 318.73 72.1568 314.438Z"
            fill="#3A86FF"
          />
          <path
            d="M72.1566 312.691C71.7239 316.984 55.2351 313.348 35.3171 304.57C16.6009 296.321 1.52219 286.47 0.112069 281.76C0.0159244 281.456 -0.0161239 281.168 0.0159244 280.911C0.432552 276.618 16.9374 280.254 36.8554 289.032C56.7734 297.81 72.5893 308.398 72.1566 312.691Z"
            fill="#9A3B82"
          />
          <path
            d="M29.5155 218.648C31.2301 215.124 34.8035 212.882 38.7294 212.882H50.0585L50.6514 258.406L58.5513 300.245L61.0671 313.54C54.401 312.067 45.2993 308.975 35.3323 304.586C29.6918 302.103 22.6252 298.419 17.9141 295.824V240.433C17.9141 239.68 18.0583 238.927 18.3147 238.223L29.5155 218.648Z"
            fill="#A0505A"
          />
          <path
            d="M61.0514 313.54C54.3854 312.067 45.2837 308.975 35.3167 304.586C29.6762 302.103 22.6095 298.419 17.8984 295.824V281.904C23.0422 283.554 30.6537 286.309 36.855 289.032C45.2196 292.717 52.5266 296.513 58.5517 300.245L61.0514 313.54Z"
            fill="#73325A"
          />
          <path
            d="M103.243 161.704L42.9763 272.55C40.7489 276.65 34.6117 277.628 29.2756 274.728C23.9396 271.829 21.4238 266.158 23.6512 262.042L83.918 151.196L103.243 161.704Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M103.224 161.731C105.456 157.627 102.94 151.951 97.6062 149.053C92.2722 146.155 86.1394 147.133 83.9082 151.237C81.6769 155.341 84.1922 161.017 89.5262 163.915C94.8602 166.813 100.993 165.835 103.224 161.731Z"
            fill="#3A86FF"
            stroke="#06D6A0"
            strokeWidth="4.9999"
            stroke-miterlimit="9.9997"
          />
          <path
            d="M63.8721 204.136L92.347 180.894L91.8983 189.159L101.016 191.434L80.2487 204.248C85.8251 203.287 92.5393 202.502 98.0676 202.935C104.654 203.447 102.442 211.152 99.9745 217.735C105.743 217.175 125.084 205.465 132.375 207.676C136.83 209.022 135.228 218.104 133.946 223.118C135.804 223.214 145.211 223.102 145.211 223.102L140.243 227.635L142.967 232.168C132.391 232.632 132.263 230.966 133.593 223.47C133.817 215.317 124.78 223.15 105.535 227.747C96.0005 230.021 97.2343 223.822 99.5899 217.367C98.6444 214.404 91.5778 211.184 68.8716 217.111L63.8721 204.136Z"
            fill="#FE5244"
          />
          <path
            d="M64.2886 218.296C68.9348 218.296 72.7013 214.531 72.7013 209.887C72.7013 205.242 68.9348 201.477 64.2886 201.477C59.6425 201.477 55.876 205.242 55.876 209.887C55.876 214.531 59.6425 218.296 64.2886 218.296Z"
            fill="white"
            stroke="#FE5244"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M61.3888 212.882V213.41C61.3888 218.793 57.0302 223.166 51.6301 223.166H41.3906V212.882H61.3888Z"
            fill="#A0505A"
          />
          <path
            d="M73.8556 232.632L71.1475 238.976L67.9907 246.392L66.2761 250.413L63.6642 256.547C63.6001 256.708 63.504 256.884 63.4238 257.028C63.4238 257.044 63.4078 257.044 63.4078 257.06C62.5746 258.502 60.9561 259.399 59.1774 259.399H38.4262C35.9104 259.399 34.1958 257.012 35.1252 254.818L36.6315 251.277L39.9485 243.493L42.8008 236.781L45.3166 230.886C46.0537 229.156 47.8324 228.019 49.8194 228.019H70.5706C73.0704 228.051 74.785 230.438 73.8556 232.632Z"
            fill="#A0505A"
          />
          <path
            d="M43.666 236.813C44.5313 235.852 45.7812 235.275 47.1272 235.275H66.9491C69.0322 235.275 70.5385 237.069 70.3302 238.976"
            stroke="#73325A"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M40.9736 243.525C41.8229 242.676 42.9927 242.179 44.2586 242.179H64.0804C66.3559 242.179 67.9262 244.294 67.3494 246.376"
            stroke="#73325A"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M37.8652 251.294C38.7145 250.493 39.8522 250.028 41.0701 250.028H60.8919C63.2314 250.028 64.8499 252.303 64.0967 254.449"
            stroke="#73325A"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M109.54 46.3248C110.87 44.8991 112.2 43.5696 113.514 42.3843C114.796 42.977 116.014 43.7939 117.119 44.819C118.209 45.8442 119.122 46.9975 119.812 48.2309C118.722 49.6245 117.504 51.0501 116.174 52.4757C109.54 59.6039 102.698 64.0089 100.855 62.3109C99.0282 60.613 102.906 53.4529 109.54 46.3248Z"
            fill="#06D6A0"
          />
          <path
            d="M62.9747 102.773L60.8595 104.086C53.1839 108.844 38.2334 98.6081 27.4812 81.2284C16.713 63.8486 14.2132 45.9242 21.8727 41.1668L24.052 39.8213L37.0156 77.9446L62.9747 102.773Z"
            fill="#3A86FF"
          />
          <path
            d="M84.4466 123.324L62.9743 102.773L36.9992 77.9285L24.0356 39.8212L12.4502 5.75049L66.4035 49.2079L84.4466 123.324Z"
            fill="#3A86FF"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M86.1292 121.29L68.2142 47.3019L13.5879 4.29297"
            stroke="#9A3B82"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M55.9401 70.9285C54.562 65.226 58.0713 59.4755 63.7759 58.0979C69.192 56.7844 74.6883 59.8759 76.3869 65.1619L80.8897 79.6904C83.3734 87.7316 94.9589 87.1069 96.5773 78.8415L99.1732 65.4983"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M99.7817 65.8671C100.853 65.8671 101.721 64.9994 101.721 63.9289C101.721 62.8585 100.853 61.9907 99.7817 61.9907C98.7109 61.9907 97.8428 62.8585 97.8428 63.9289C97.8428 64.9994 98.7109 65.8671 99.7817 65.8671Z"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_361_258">
            <rect width="547" height="380" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    icon: (
      <svg
        width="581"
        height="438"
        viewBox="0 0 581 438"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_362_562)">
          <path
            d="M578.001 437.444L395.768 437.768C373.432 437.923 349.704 438 325.095 438C265.195 438 210.444 437.505 168.568 436.687H0C0 406.928 32.7707 420 41.4117 425.253C51.4593 431.356 38.521 398.863 59.0337 398.863C76.5938 398.863 86.6414 407.685 86.6414 407.685C86.6414 407.685 87.1206 390.535 103.769 390.288C120.417 390.041 130.99 404.703 144.129 416.77C149.555 421.746 156.078 425.701 162.246 428.714C204.863 427.818 262.119 427.262 325.095 427.262C354.928 427.262 383.464 427.385 409.788 427.617C456.564 427.617 499.398 403.035 511.548 396.87C541.567 381.604 527.346 417.991 527.346 417.991C527.346 417.991 550.486 408.257 566.763 408.334C589.749 408.427 578.001 437.444 578.001 437.444Z"
            fill="#D0F0E4"
          />
          <path
            d="M483.446 436.548C483.446 436.548 488.052 395.108 458.064 381.774C458.064 381.774 453.643 426.86 468.606 423.909C474.217 422.796 462.175 411.857 442.544 411.394C442.544 411.394 457.584 436.656 475.856 437.011"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M475.918 436.949C475.918 436.949 477.649 417.991 496.137 412.089C512.831 406.774 483.616 436.486 483.616 436.486"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M60.7801 435.219C60.7801 435.219 34.2699 417.064 26.8037 387.445C26.8037 387.445 50.2688 394.46 60.2237 409.385C60.2237 409.385 64.3045 375.409 74.1667 363.975C74.1667 363.975 79.4996 371.639 80.1643 400.037C80.1643 400.037 92.2524 379.457 101.249 372.813C101.249 372.813 100.012 399.589 93.5818 413.263C93.5818 413.263 102.872 406.032 109.148 413.124C115.424 420.216 103.119 430.599 103.119 430.599"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M74.1824 364.979C74.1824 364.979 74.4452 426.876 71.6318 434.894"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M100.384 374.374C100.384 374.374 81.8959 421.854 71.6318 434.894"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M93.3035 413.48C92.6233 415.967 87.9396 422.827 87.0121 419.876C86.1001 416.925 94.5246 412.151 96.6424 411.363"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M60.2389 409.401C61.491 411.811 65.7265 418.579 61.4446 418.409C58.6468 418.3 60.9964 404.101 60.9964 404.101"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M409.727 384.339C399.215 389.484 400.205 399.358 400.112 405.986C400.004 413.047 386.524 416.74 386.524 416.74C390.111 405.445 387.56 393.811 387.56 393.811L409.727 384.339Z"
            fill="#A0505A"
          />
          <path
            d="M420.871 410.343L418.475 411.641L413.452 400.161C413.189 399.559 412.601 399.203 411.999 399.203C411.798 399.203 411.581 399.25 411.38 399.327C410.87 399.543 410.499 400.022 410.437 400.578L408.227 417.219L379.151 433.04C378.285 430.97 383.68 425.779 386.539 416.74C386.539 416.74 400.034 413.047 400.127 405.986C400.22 399.358 399.246 389.469 409.742 384.339L411.952 383.397C424.009 388.944 420.871 410.343 420.871 410.343Z"
            fill="#FFCF2D"
          />
          <path
            d="M411.937 301.878V383.397L387.884 393.826L369.86 311.983C377.929 312.292 391.378 310.593 411.937 301.878Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M394.253 309.047L398.998 388.974"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M411.937 301.878V323.216L371.004 317.298L369.86 311.983C377.929 312.292 391.378 310.593 411.937 301.878Z"
            fill="#9A3B82"
          />
          <path
            d="M533.158 246.564L517.607 249.84C517.081 249.948 516.556 249.778 516.185 249.392C515.922 249.098 515.783 248.743 515.783 248.372C515.783 247.97 515.938 247.569 516.262 247.275L524.919 239.163L523.002 237.448C523.002 237.448 502.907 241.388 501.763 253.919L503.293 255.587C511.192 263.344 519.709 259.342 525.661 257.333C531.349 255.418 538.135 264.24 539.48 266.063C539.495 266.063 539.526 266.063 539.542 266.063C548.507 265.77 554.861 268.952 556.422 267.516L533.158 246.564Z"
            fill="#FFCF2D"
          />
          <path
            d="M503.309 255.587C511.208 263.344 519.725 259.342 525.676 257.333C532.014 255.201 539.573 266.063 539.573 266.063C528.35 266.418 518.782 272.367 518.782 272.367L503.309 255.587Z"
            fill="#A0505A"
          />
          <path
            d="M407.284 302.574C407.284 302.574 411.195 328.979 441.199 328.485C471.203 327.99 518.457 272.213 518.457 272.213L501.84 254.012L407.284 302.574Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M424.581 295.404C425.57 302.357 430.239 308.908 444.475 308.676C465.622 308.337 495.502 280.602 511.3 264.255"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M538.244 200.15C535.508 199.115 529 202.668 524.1 208.849C518.829 215.477 516.695 222.523 519.014 224.361L444.77 184.9C441.122 182.969 436.917 186.275 437.953 190.261L460.429 275.365C384.299 324.745 359.891 309.944 359.891 309.944V30.2836C359.891 30.299 359.891 30.299 359.906 30.3145C360.555 31.9677 367.527 30.8089 375.488 27.7033C382.815 24.8603 388.41 21.3684 388.766 19.5452L388.781 19.5298V107.646C388.781 113.177 391.765 118.261 396.588 120.964L538.244 200.15Z"
            fill="#3A86FF"
          />
          <path
            d="M538.244 200.15C535.508 199.115 529 202.668 524.1 208.849C518.829 215.477 516.695 222.523 519.014 224.361L444.77 184.9C441.122 182.969 436.917 186.275 437.953 190.261L460.429 275.704C441.075 288.266 425.061 296.331 411.937 301.894C391.378 310.592 377.93 312.307 369.861 311.998C362.828 311.736 359.891 309.943 359.891 309.943V30.2836C359.891 30.299 359.891 30.299 359.906 30.3145C360.555 31.9677 367.527 30.8089 375.488 27.7033C382.815 24.8603 388.41 21.3684 388.766 19.5452L388.781 19.5298V107.646C388.781 113.177 391.765 118.261 396.588 120.964L538.244 200.15Z"
            fill="#3A86FF"
          />
          <path
            d="M431.754 178.04L519.014 225.35"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M398.659 122.108L388.874 178.951L438.818 144.573L398.659 122.108Z"
            fill="#FFCF2D"
          />
          <path
            d="M398.659 122.108L388.874 178.951L438.818 144.573"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M398.257 12.3914L333.782 25.6019C331.402 26.0963 328.944 23.9796 328.31 20.8739C327.676 17.7683 329.098 14.8636 331.479 14.3691L395.954 1.15869L398.257 12.3914Z"
            fill="white"
            stroke="#3FB1B5"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M398.221 12.4006C400.605 11.9123 402.021 9.00233 401.385 5.90108C400.749 2.79982 398.302 0.681638 395.918 1.16998C393.535 1.65832 392.118 4.56826 392.754 7.66952C393.39 10.7708 395.838 12.889 398.221 12.4006Z"
            fill="white"
            stroke="#3FB1B5"
            strokeWidth="4.9998"
            stroke-miterlimit="9.9997"
            strokeLinecap="round"
          />
          <path
            d="M361.467 18.0155C361.467 18.0155 340.615 41.4389 342.887 46.5995C345.855 49.5506 348.266 50.8485 347.911 51.9455C347.524 53.1352 342.532 60.3198 342.532 60.3198L342.037 54.9893L337.26 56.5653C337.26 56.5653 342.3 49.2107 342.624 46.9548C340.553 45.3789 336.333 42.1033 336.472 39.8166C336.627 37.3908 344.016 28.7692 349.379 22.8207L341.295 25.4937L339.703 18.0309L354.249 15.3579L361.467 18.0155Z"
            fill="#3A86FF"
          />
          <path
            d="M358.638 19.0353C361.063 19.0353 363.028 17.0708 363.028 14.6473C363.028 12.2239 361.063 10.2593 358.638 10.2593C356.214 10.2593 354.248 12.2239 354.248 14.6473C354.248 17.0708 356.214 19.0353 358.638 19.0353Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M388.766 19.5454C388.411 21.3686 382.815 24.8605 375.488 27.7035C367.527 30.7936 360.556 31.9679 359.906 30.3147C359.906 30.2992 359.906 30.2992 359.891 30.2838C359.334 28.6151 365.239 24.7987 373.154 21.724C381.114 18.6339 388.086 17.4596 388.735 19.1128C388.782 19.2364 388.797 19.3755 388.766 19.5454Z"
            fill="#9A3B82"
          />
          <path
            d="M383.402 6.56671L382.552 18.8347L382.15 24.706C380.217 25.7257 377.945 26.7455 375.487 27.7034C371.314 29.3258 367.418 30.4073 364.559 30.8554V19.6381L376.291 17.2278C376.291 17.2278 376.94 13.0406 378.177 9.53327C379.398 6.01048 383.402 6.56671 383.402 6.56671Z"
            fill="#A0505A"
          />
          <path
            d="M376.616 16.7178C376.446 17.4131 371.345 19.0354 371.345 22.7436"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M382.552 18.8345L382.15 24.7058C380.217 25.7255 377.945 26.7453 375.487 27.7032C371.314 29.3256 367.418 30.4071 364.559 30.8552V25.7873C366.846 24.4431 369.83 23.0216 373.153 21.7238C376.616 20.3641 379.893 19.3753 382.552 18.8345Z"
            fill="#73325A"
          />
          <path
            d="M374.869 12.7006L361.776 15.698C361.081 15.8525 360.432 15.2963 360.432 14.5238V6.58205C360.432 5.51594 361.081 4.58889 362.024 4.27987L374.962 0.0617989C375.781 -0.200865 376.601 0.44807 376.601 1.35967V10.4139C376.585 11.5109 375.874 12.4688 374.869 12.7006Z"
            fill="#A0505A"
          />
          <path
            d="M365.069 14.462C364.358 14.6165 363.678 14.0757 363.678 13.334V5.71679C363.678 4.69704 364.342 3.80089 365.316 3.50732"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M368.84 13.6429C368.129 13.7974 367.449 13.2412 367.449 12.4841V4.63504C367.449 3.58438 368.114 2.65734 369.088 2.36377"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M373.061 12.7469C372.35 12.9014 371.67 12.3297 371.67 11.5572V3.43007C371.67 2.34851 372.335 1.39056 373.308 1.08154"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M532.493 215.508C527.222 222.152 521.317 226.185 518.999 224.346C516.68 222.507 518.813 215.477 524.084 208.833C529 202.653 535.492 199.099 538.228 200.135L538.769 200.444C541.104 202.298 537.765 208.88 532.493 215.508Z"
            fill="#9A3B82"
          />
          <path
            d="M556.345 226.679L552.836 228.533C551.444 229.275 549.713 228.75 548.971 227.359L545.277 220.499L539.681 218.583C540.299 218.815 542.711 220.051 541.953 224.547L528.814 219.649L524.3 217.965L520.019 215.23C521.023 213.191 522.399 210.997 524.115 208.849C525.552 207.041 527.114 205.465 528.675 204.167L533.142 207.289L537.718 207.783L545.153 208.571C546.343 208.695 547.487 209.096 548.492 209.73L554.428 213.948C555.293 214.566 555.865 215.493 556.004 216.544L557.21 224.98C557.318 225.675 556.963 226.355 556.345 226.679Z"
            fill="#A0505A"
          />
          <path
            d="M547.704 212.943L552.852 216.605C553.594 217.131 554.088 217.949 554.227 218.861L555.278 225.675C555.356 226.277 555.062 226.865 554.521 227.143"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M544.52 214.164L549.667 217.826C550.409 218.351 550.904 219.17 551.043 220.082L552.094 226.896C552.171 227.498 551.877 228.085 551.336 228.363"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M539.681 218.567L535.94 217.3"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M537.718 207.783C536.466 210.147 534.642 212.835 532.508 215.524C531.287 217.053 530.051 218.444 528.814 219.649L524.3 217.965L520.019 215.23C521.023 213.191 522.399 210.997 524.115 208.849C525.552 207.041 527.114 205.465 528.675 204.167L533.142 207.289L537.718 207.783Z"
            fill="#73325A"
          />
          <path
            d="M402.74 80.8545L435.805 95.5173L447.599 130.004L423.639 112.884L412.463 99.241L402.74 80.8545Z"
            fill="#3A86FF"
          />
          <path
            d="M412.463 99.2408C412.463 99.2408 423.283 101.095 427.643 113.147L429.946 110.829C429.946 110.829 425.757 99.1018 414.689 96.0889L412.463 99.2408Z"
            fill="#9A3B82"
          />
          <path
            d="M476.954 114.213C473.244 112.111 469.812 110.953 468.715 111.37C468.792 111.184 468.838 110.968 468.823 110.752C468.761 110.072 468.205 109.562 467.54 109.562C467.509 109.562 467.478 109.562 467.432 109.562C466.721 109.624 466.195 110.242 466.241 110.953C466.241 110.999 466.257 111.045 466.257 111.076L462.331 113.595C461.45 114.166 460.367 114.197 459.44 113.687C458.513 113.177 457.972 112.25 457.972 111.2V105.56C457.972 103.104 456.75 100.832 454.694 99.4726C452.639 98.1129 450.057 97.8966 447.8 98.8546L440.319 102.192L437.474 93.8639L404.24 79.1393C404.039 79.0466 403.792 79.1393 403.699 79.3556C403.606 79.5565 403.699 79.8037 403.915 79.8964L436.81 94.482L448.542 128.798C448.604 128.968 448.759 129.076 448.929 129.076C448.975 129.076 449.021 129.061 449.068 129.061C449.284 128.984 449.392 128.752 449.331 128.536L440.597 102.98L448.14 99.6117C450.15 98.7464 452.438 98.9473 454.246 100.152C456.07 101.358 457.152 103.366 457.152 105.56V111.2C457.152 112.559 457.863 113.765 459.054 114.414C459.61 114.723 460.213 114.877 460.816 114.877C461.496 114.877 462.176 114.676 462.779 114.29L466.674 111.802C466.906 112.019 467.215 112.142 467.54 112.142C467.571 112.142 467.617 112.142 467.648 112.142C467.926 112.127 468.174 112.019 468.359 111.849C468.359 112.946 471.173 115.402 475.037 117.596C475.872 118.075 476.706 118.508 477.495 118.879C477.974 118.477 478.376 117.998 478.701 117.426C479.025 116.87 479.226 116.268 479.319 115.65C478.577 115.186 477.789 114.692 476.954 114.213ZM467.571 111.493C467.215 111.524 466.922 111.262 466.891 110.922C466.86 110.582 467.123 110.273 467.463 110.242C467.803 110.211 468.112 110.474 468.143 110.814C468.174 111.153 467.911 111.462 467.571 111.493Z"
            fill="#FFCF2D"
          />
          <path
            d="M410.314 119.559L404.595 151.357L424.087 136.339V116.515L410.314 119.559Z"
            fill="#A0505A"
          />
          <path
            d="M410.315 119.559L409.604 123.545L418.229 140.85L424.088 136.339V116.515L410.315 119.559Z"
            fill="#73325A"
          />
          <path
            d="M412.787 99.5656C412.787 99.5656 403.034 97.1398 399.988 102.795C396.943 108.45 405.847 110.01 406.218 108.033C406.388 107.167 390.188 107.183 392.909 119.435C395.737 132.198 408.49 127.81 408.49 127.81L409.974 119.559L412.787 99.5656Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
          />
          <path
            d="M423.932 117.859C423.932 117.859 409.371 136.833 422.17 144.898C432.434 151.357 435.078 142.256 432.326 141.005C429.343 139.645 422.495 165.293 443.579 165.216C464.71 165.139 458.249 138.764 447.599 130.019C442.513 125.848 425.54 114.182 425.54 114.182L423.932 117.859Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
          />
          <path
            d="M423.5 113.1L424.597 113.796C425.664 114.475 425.973 115.882 425.308 116.948L425.092 117.272C424.412 118.338 423.005 118.663 421.938 117.983L420.764 117.241C419.465 118.168 411.659 123.375 406.836 118.199C402.152 113.178 412.973 98.4839 412.973 98.4839C422.155 101.358 425.741 109.516 425.741 109.516L423.5 113.1Z"
            fill="#A0505A"
          />
          <path
            d="M409.959 101.821C409.959 101.821 412.494 102.764 412.247 104.942C411.999 107.121 409.712 110.551 410.253 111.138C410.794 111.725 411.52 111.833 411.52 111.833"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M409.341 113.147C409.341 113.147 411.227 114.198 413.793 113.796"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M417.422 110.063C417.641 109.489 417.567 108.928 417.256 108.809C416.944 108.69 416.515 109.06 416.296 109.634C416.077 110.208 416.152 110.769 416.463 110.888C416.774 111.007 417.204 110.637 417.422 110.063Z"
            fill="#73325A"
          />
          <path
            d="M410.281 106.787C410.463 106.309 410.398 105.839 410.134 105.739C409.871 105.639 409.51 105.945 409.327 106.424C409.145 106.902 409.21 107.371 409.474 107.472C409.737 107.572 410.098 107.265 410.281 106.787Z"
            fill="#73325A"
          />
          <path
            d="M422.696 115.758C423.129 115.078 424.026 114.877 424.706 115.31"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M416.992 105.978C416.992 105.978 418.878 106.487 419.852 108.728"
            stroke="#73325A"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M419.806 102.223C419.806 102.223 417.75 109.037 423.639 113.688C427.102 116.422 427.303 113.131 427.303 113.131C427.303 113.131 426.854 106.441 419.806 102.223Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
          />
          <path
            d="M283.251 276.832C281.628 270.915 254.824 276.462 225.299 287.2C197.058 297.475 174.103 311.334 173.855 316.912L158.366 203.982C158.135 202.39 156.774 201.216 155.167 201.216C154.27 201.216 153.466 201.571 152.879 202.159C152.292 202.746 151.936 203.549 151.936 204.445V300.889C151.75 298.247 144.934 296.131 136.555 296.131C128.177 296.131 121.376 298.247 121.175 300.889V192.517C121.175 183.37 125.967 174.903 133.788 170.175L143.944 164.041L185.773 138.795L224.681 115.124V74.7202C224.681 76.4507 231.838 77.8413 240.278 77.8413C248.702 77.8413 255.875 76.4662 255.875 74.7202V118.523C255.875 128.226 251.129 137.389 243.555 143.445L219.889 160.349C215.854 163.223 214.88 168.816 217.694 172.895C233.384 195.592 281.597 261.83 283.235 276.4C283.251 276.539 283.251 276.693 283.251 276.832Z"
            fill="#06D6A0"
          />
          <path
            d="M224.217 111.663V123.56"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M143.976 164.042L195.559 198.528L185.805 138.795L174.629 145.408L177.256 169.897L155.09 157.089L143.976 164.042Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M281.597 278.316C279.742 273.202 255.164 279.104 225.624 289.842C196.084 300.581 173.407 314.162 175.278 319.276C177.133 324.39 202.839 319.106 232.379 308.368C261.919 297.629 283.468 283.43 281.597 278.316Z"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M214.324 385.003L212.624 387.97L210.738 391.276C194.43 393.316 191.555 382.655 191.555 382.655L194.012 377.772C200.598 381.821 208.945 383.968 214.324 385.003Z"
            fill="#E57281"
          />
          <path
            d="M273.064 307.425C261.471 327.403 219.781 385.869 219.781 385.869C219.781 385.869 217.601 385.637 214.324 385.004C208.945 383.953 200.598 381.821 193.997 377.773C192.467 376.83 191.045 375.795 189.762 374.636L219.982 313.296L227.618 297.212L231.854 288.281C232.364 288.096 232.874 287.926 233.368 287.756C233.616 287.663 233.863 287.586 234.126 287.493C234.883 287.231 235.625 286.984 236.367 286.736C236.986 286.536 237.588 286.335 238.191 286.118C240.031 285.5 241.839 284.929 243.602 284.372C255.442 280.633 265.567 278.115 272.4 277.342C273.914 279.459 275.646 282.503 276.635 286.319C278.073 291.897 277.903 299.097 273.064 307.425Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M222.455 430.599C221.93 432.901 219.07 433.72 217.401 432.051L180.039 394.83L191.725 382.64C191.725 382.64 194.43 393.285 210.754 391.261C223.939 411.162 223.909 424.187 222.455 430.599Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M220.925 432.948C218.39 433.921 215.53 433.411 213.474 431.603L193.966 414.468C193.487 414.036 193.425 413.309 193.827 412.8C194.214 412.321 194.183 411.61 193.734 411.177L192.142 409.632C191.709 409.2 191.014 409.184 190.55 409.586L190.179 409.895C189.731 410.281 189.082 410.281 188.649 409.895L178.168 400.794C176.808 399.62 176.762 397.519 178.045 396.267L179.869 394.506L217.462 432.438C218.544 433.519 220.106 433.566 221.219 432.839L220.925 432.948Z"
            fill="#3A86FF"
          />
          <path
            d="M215.839 396.236C215.839 396.236 219.008 399.048 211.434 402.463"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M217.833 399.62C217.833 399.62 221.002 402.432 213.428 405.847"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M219.827 403.004C219.827 403.004 222.996 405.816 215.422 409.231"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M276.635 286.319C266.587 286.304 256.292 288.05 246.369 290.8C245.58 288.019 244.467 285.809 243.602 284.372C255.442 280.633 265.567 278.115 272.4 277.342C273.93 279.474 275.661 282.518 276.635 286.319Z"
            fill="#9A3B82"
          />
          <path
            d="M171.861 383.443L168.877 387.259L166.528 390.257C150.096 389.932 148.782 378.978 148.782 378.978L152.353 373.863C158.552 378.838 166.93 381.929 171.861 383.443Z"
            fill="#E57281"
          />
          <path
            d="M246.708 303.299C245.812 307.116 243.895 311.226 240.371 315.459C225.902 332.872 175.942 384.571 175.942 384.571C175.942 384.571 156.434 380.183 148.103 369.676L181.739 321.918L194.152 304.288C202.715 299.73 213.598 294.894 225.624 290.506C231.9 288.219 237.944 286.164 243.601 284.372C244.452 285.809 245.58 288.034 246.368 290.8C247.358 294.23 247.837 298.525 246.708 303.299Z"
            fill="white"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M172.464 430.861C171.614 433.071 168.677 433.473 167.255 431.572L135.612 389.376L148.922 378.978C148.922 378.978 150.065 389.932 166.513 390.257C176.73 411.841 174.829 424.727 172.464 430.861Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M170.625 432.839C167.981 433.441 165.214 432.514 163.452 430.459L146.603 410.744C146.186 410.25 146.232 409.524 146.696 409.076C147.16 408.658 147.206 407.948 146.835 407.453L145.475 405.707C145.104 405.228 144.424 405.105 143.898 405.429L143.496 405.692C143.001 406.001 142.368 405.908 141.981 405.476L132.861 395.015C131.686 393.656 131.934 391.585 133.387 390.535L135.443 389.051L167.239 431.835C168.151 433.055 169.697 433.318 170.903 432.777L170.625 432.839Z"
            fill="#3A86FF"
          />
          <path
            d="M171.181 396.004C171.181 396.004 173.918 399.234 165.926 401.536"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M172.99 399.635C172.99 399.635 175.726 402.864 167.734 405.167"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M174.474 403.266C174.474 403.266 177.21 406.495 169.219 408.798"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M246.383 290.8C239.922 292.592 233.615 294.802 227.633 297.196C201.803 307.595 182.001 321.717 181.754 321.887L194.167 304.257C202.73 299.699 213.613 294.863 225.639 290.475C227.741 289.718 229.812 288.977 231.868 288.25C232.378 288.065 232.889 287.895 233.383 287.725C233.631 287.632 233.878 287.555 234.141 287.462C234.898 287.2 235.64 286.952 236.382 286.705C237 286.504 237.603 286.304 238.206 286.087C240.046 285.469 241.854 284.898 243.616 284.341C244.467 285.825 245.579 288.034 246.383 290.8Z"
            fill="#9A3B82"
          />
          <path
            d="M151.596 302.975C151.596 305.664 144.872 307.858 136.571 307.858C128.27 307.858 121.546 305.679 121.546 302.975C121.546 302.945 121.546 302.898 121.546 302.867C121.731 300.225 128.394 298.108 136.571 298.108C144.748 298.108 151.411 300.225 151.596 302.867C151.596 302.898 151.596 302.945 151.596 302.975Z"
            fill="white"
            stroke="#3FB1B5"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M145.536 299.344V312.03C145.536 316.139 143.264 319.894 139.647 321.825L133.479 325.101C131.98 325.904 130.295 326.322 128.594 326.322C127.868 326.322 127.373 325.719 127.373 325.085C127.373 324.823 127.466 324.545 127.651 324.313L129.955 321.532C130.279 321.146 130.001 320.574 129.506 320.574H115.95L113.477 323.695C112.163 325.348 110.153 326.322 108.051 326.322H107.34C106.459 326.322 105.918 325.379 106.35 324.622L106.629 324.112C105.779 324.467 104.851 324.668 103.908 324.668H103.197C102.316 324.668 101.775 323.726 102.208 322.969L107.757 316.85L111.606 315.336V315.351L130.728 307.842V298.819C132.536 298.587 134.499 298.448 136.571 298.448C139.925 298.433 143.017 298.773 145.536 299.344Z"
            fill="#E57281"
          />
          <path
            d="M111.112 315.985L106.475 323.942"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M128.78 322.922L131.625 319.446C132.181 318.766 131.702 317.762 130.821 317.762"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M145.536 299.345V307.271C143.017 307.842 139.925 308.182 136.571 308.182C134.499 308.182 132.536 308.059 130.728 307.812V298.788C132.536 298.557 134.499 298.417 136.571 298.417C139.91 298.433 143.017 298.773 145.536 299.345Z"
            fill="#9A3B82"
          />
          <path
            d="M255.55 73.0671C255.55 74.8131 248.718 76.1882 240.293 76.1882C231.869 76.1882 225.036 74.8131 225.036 73.0671C225.036 71.3212 231.869 69.8843 240.293 69.8843C248.718 69.8843 255.55 71.3367 255.55 73.0671Z"
            stroke="#3FB1B5"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M235.64 75.6163C233.754 75.4927 232.039 75.3073 230.555 75.0446V60.0419C230.555 59.5475 230.663 59.053 230.879 58.6049L235.733 48.5928C236.63 46.7387 238.516 45.5645 240.571 45.5645H246.523L233.507 69.4978C233.445 69.6059 233.399 69.7141 233.353 69.8222C232.595 71.6918 233.538 74.0867 235.64 75.6163Z"
            fill="#E57281"
          />
          <path
            d="M246.832 69.5444L248.749 66.207V75.2612C247.172 75.4621 245.394 75.632 243.493 75.7093L246.832 69.5444Z"
            fill="#9A3B82"
          />
          <path
            d="M274.872 17.1507L243.183 75.4312C242.009 77.5943 238.793 78.1042 235.98 76.5746C233.167 75.0449 231.853 72.0629 233.028 69.9153L264.716 11.6348L274.872 17.1507Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M274.865 17.1739C276.039 15.0147 274.716 12.0289 271.911 10.505C269.106 8.98106 265.88 9.49608 264.706 11.6553C263.532 13.8145 264.854 16.8003 267.659 18.3242C270.465 19.8481 273.691 19.3331 274.865 17.1739Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="4.9999"
            stroke-miterlimit="9.9997"
          />
          <path
            d="M255.457 38.5346L270.436 26.1431L270.204 30.6547L274.996 31.8444L263.557 38.9054C272.337 37.0204 288.104 34.3629 290.5 38.9982C291.443 40.8213 289.665 44.545 288.475 47.218C287.733 52.8575 317.319 45.8738 317.66 45.7965L313.099 50.0146L317.66 52.6103C317.66 52.6103 292.834 57.3383 286.435 56.0404C282.817 55.2988 285.693 50.4472 288.212 46.8935C288.985 44.1587 282.833 43.2626 257.25 46.0437L255.457 38.5346Z"
            fill="#3A86FF"
          />
          <path
            d="M255.674 45.9819C258.116 45.9819 260.095 44.0035 260.095 41.563C260.095 39.1225 258.116 37.144 255.674 37.144C253.232 37.144 251.253 39.1225 251.253 41.563C251.253 44.0035 253.232 45.9819 255.674 45.9819Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M259.136 56.3647L257.714 59.7021L256.044 63.5957L255.148 65.7125L253.772 68.9417C253.741 69.0344 253.695 69.1117 253.648 69.2044C253.648 69.2044 253.648 69.2198 253.633 69.2198C253.185 69.9769 252.335 70.4559 251.407 70.4559H240.494C239.18 70.4559 238.268 69.2044 238.762 68.0456L239.551 66.1915L241.298 62.097L242.797 58.5742L244.111 55.4686C244.497 54.557 245.44 53.9699 246.476 53.9699H257.389C258.734 53.9544 259.631 55.2059 259.136 56.3647Z"
            fill="#E57281"
          />
          <path
            d="M243.184 58.5588C243.632 58.0489 244.297 57.7554 245.008 57.7554H255.426C256.524 57.7554 257.312 58.6979 257.204 59.7022"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M241.762 62.097C242.21 61.6489 242.828 61.3862 243.493 61.3862H253.912C255.102 61.3862 255.937 62.4987 255.627 63.5957"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M240.123 66.1761C240.571 65.7589 241.174 65.5117 241.808 65.5117H252.227C253.463 65.5117 254.313 66.7014 253.911 67.8293"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M252.505 45.5493V45.8274C252.505 48.6549 250.217 50.9571 247.373 50.9571H241.993V45.5493H252.505Z"
            fill="#E57281"
          />
          <path
            d="M121.87 166.421C121.375 167.163 120.865 167.858 120.355 168.491C119.799 168.352 119.257 168.121 118.763 167.781C118.268 167.441 117.851 167.039 117.511 166.56C117.913 165.865 118.361 165.123 118.871 164.382C121.375 160.673 124.065 158.124 124.9 158.68C125.734 159.236 124.374 162.713 121.87 166.421Z"
            fill="#FFCF2D"
          />
          <path
            d="M144.655 110.752L125.348 139.243C125.116 139.583 125.441 140 125.827 139.892L135.056 136.926C133.927 138.27 133.232 140.016 133.232 141.901V150.878C133.232 154.385 130.434 157.243 126.94 157.336C126.724 156.934 126.291 156.656 125.781 156.656C125.426 156.656 125.101 156.795 124.854 157.043C124.606 157.29 124.467 157.614 124.483 157.97C124.483 158.68 125.07 159.268 125.797 159.268C126.446 159.268 126.987 158.773 127.08 158.155C130.944 157.985 134.051 154.787 134.051 150.878V141.901C134.051 139.645 135.164 137.59 136.833 136.354L155.398 130.39L179.234 110.752H144.655ZM126.137 158.279C126.044 158.371 125.92 158.418 125.797 158.418C125.673 158.418 125.549 158.371 125.456 158.279C125.364 158.186 125.317 158.062 125.317 157.939C125.317 157.815 125.364 157.692 125.456 157.599C125.549 157.506 125.673 157.46 125.797 157.46C125.936 157.46 126.044 157.506 126.137 157.599C126.229 157.692 126.276 157.8 126.276 157.939C126.291 158.078 126.229 158.186 126.137 158.279Z"
            fill="#3FB1B5"
          />
          <path
            d="M123.663 139.181C123.586 139.181 123.508 139.166 123.431 139.104C123.246 138.98 123.199 138.718 123.323 138.532L143.449 108.836H179.899C180.131 108.836 180.316 109.021 180.316 109.253C180.316 109.485 180.131 109.67 179.899 109.67H143.882L124.003 138.996C123.926 139.12 123.802 139.181 123.663 139.181Z"
            fill="#3FB1B5"
          />
          <path
            d="M144.005 134.392L141.687 133.341L141.81 132.985C141.857 132.846 142.985 129.571 145.767 126.094C148.349 122.865 152.878 118.894 159.85 118.214L160.251 118.184L160.653 121.104L159.834 121.212L159.54 119.08C153.079 119.821 148.844 123.56 146.417 126.604C144.237 129.324 143.093 131.981 142.738 132.908L144.361 133.65L144.005 134.392Z"
            fill="white"
          />
          <path
            d="M155.754 156.919L151.07 141.623L162.03 136.261L166.544 139.691L174.304 145.578L176.653 168.971L155.754 156.919Z"
            fill="#E57281"
          />
          <path
            d="M166.544 139.691L158.181 158.325L155.754 156.919L151.07 141.623L162.03 136.261L166.544 139.691Z"
            fill="#9A3B82"
          />
          <path
            d="M157.253 142.627C156.465 142.704 154.872 141.901 153.064 140.757L150.946 142.472C149.725 143.461 147.932 143.291 146.943 142.071C146.51 141.545 146.293 140.896 146.293 140.263C146.293 139.444 146.649 138.625 147.344 138.053L148.21 137.343C145.938 135.643 144.16 134.175 144.16 134.175C144.16 134.175 148.102 122.34 160.7 121.135C160.7 121.135 167.378 134.932 167.826 136.246C168.274 137.574 161.705 142.179 157.253 142.627Z"
            fill="#E57281"
          />
          <path
            d="M148.21 137.342C145.938 135.643 144.16 134.175 144.16 134.175C144.16 134.175 145.613 129.802 149.601 126.094C145.428 130.251 151.657 134.886 148.21 137.342Z"
            fill="#FFCF2D"
          />
          <path
            d="M150.405 129.37C150.405 129.37 151.07 127.577 152.755 126.65"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M162.463 124.827C162.463 124.827 160.129 124.503 158.97 125.214C157.81 125.924 157.81 129.602 159.665 131.904"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M160.777 134.206C160.777 134.206 159.34 135.488 156.897 134.546"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M157.13 133.866C157.13 133.866 156.62 134.592 156.651 135.411"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M154.103 131.673C154.351 131.607 154.445 131.159 154.315 130.672C154.184 130.186 153.878 129.846 153.63 129.912C153.383 129.978 153.288 130.426 153.419 130.913C153.55 131.399 153.856 131.739 154.103 131.673Z"
            fill="#9A3B82"
          />
          <path
            d="M161.016 128.662C161.238 128.602 161.32 128.186 161.199 127.733C161.077 127.28 160.798 126.961 160.575 127.02C160.352 127.08 160.271 127.496 160.392 127.949C160.514 128.402 160.793 128.721 161.016 128.662Z"
            fill="#9A3B82"
          />
          <path
            d="M153.868 141.684L150.297 138.903C149.895 138.594 149.339 138.625 148.968 138.965L148.751 139.166C148.334 139.568 148.334 140.216 148.751 140.618"
            stroke="#9A3B82"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_362_562">
            <rect width="581" height="438" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    icon: (
      <svg
        width="488"
        height="355"
        viewBox="0 0 488 355"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_362_716)">
          <path
            d="M328.053 -27.6309L358.017 1.28407L388.131 164.283H105.651L328.053 -27.6309Z"
            fill="#FFCF2D"
          />
          <path
            d="M358.274 1.05713L328.22 -27.9486L333.246 -33.1715C340.65 -40.862 353.989 -39.9839 361.681 -32.5962C369.372 -25.1934 370.72 -11.8562 363.316 -4.16573L358.274 1.05713Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M363.331 -31.279L366.692 -33.8525C371.204 -37.3042 377.684 -36.3958 381.061 -31.8088L463.668 68.7425L421.381 163.041"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M462.321 73.8743C464.879 73.8743 466.954 71.8002 466.954 69.2418C466.954 66.6834 464.879 64.6094 462.321 64.6094C459.762 64.6094 457.688 66.6834 457.688 69.2418C457.688 71.8002 459.762 73.8743 462.321 73.8743Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M409.632 152.505H432.206C438.702 152.505 443.955 157.773 443.955 164.253V164.586H397.867V164.253C397.882 157.773 403.136 152.505 409.632 152.505Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M300.27 130.205H157.357C151.982 130.205 147.637 125.86 147.637 120.486V20.5403C147.637 15.1661 151.982 10.8213 157.357 10.8213H300.27C305.645 10.8213 309.99 15.1661 309.99 20.5403V120.471C310.006 125.845 305.645 130.205 300.27 130.205Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M300.361 120.91H158.826C156.721 120.91 155.025 119.199 155.025 117.11V21.4942C155.025 19.3899 156.736 17.6943 158.826 17.6943H300.361C302.466 17.6943 304.161 19.405 304.161 21.4942V117.095C304.176 119.199 302.466 120.91 300.361 120.91Z"
            fill="#3A86FF"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M163.897 26.6261H161.657C160.93 26.6261 160.324 26.0357 160.324 25.2939V23.0534C160.324 22.3267 160.915 21.7212 161.657 21.7212H163.897C164.624 21.7212 165.23 22.3116 165.23 23.0534V25.2939C165.215 26.0357 164.624 26.6261 163.897 26.6261Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M174.087 26.6261H171.846C171.119 26.6261 170.514 26.0357 170.514 25.2939V23.0534C170.514 22.3267 171.104 21.7212 171.846 21.7212H174.087C174.814 21.7212 175.419 22.3116 175.419 23.0534V25.2939C175.419 26.0357 174.814 26.6261 174.087 26.6261Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M184.276 26.6261H182.036C181.309 26.6261 180.703 26.0357 180.703 25.2939V23.0534C180.703 22.3267 181.294 21.7212 182.036 21.7212H184.276C185.003 21.7212 185.609 22.3116 185.609 23.0534V25.2939C185.609 26.0357 185.018 26.6261 184.276 26.6261Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M258.981 164.282H203.506L214.392 130.205H248.08L258.981 164.282Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M207.866 150.642L214.392 130.205H248.08L207.866 150.642Z"
            fill="#06D6A0"
          />
          <path
            d="M292.124 49.0465H265.158C262.63 49.0465 260.586 47.0027 260.586 44.4746V27.0651C260.586 24.5369 262.63 22.4932 265.158 22.4932H292.124C294.653 22.4932 296.697 24.5369 296.697 27.0651V44.4746C296.697 47.0027 294.653 49.0465 292.124 49.0465Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M268.293 28.7002H288.869"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M268.293 33.3931H288.869"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M268.293 38.0859H288.869"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M268.293 42.7788H288.869"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M299.574 120.91H192.393L186.11 129.917C179.009 140.091 164.004 140.242 156.706 130.205L118.431 77.5677C120.036 79.566 127.379 77.3407 134.374 72.7385C141.475 68.0606 146.062 62.1717 144.624 59.9917L171.166 93.8116L179.296 79.4601C181.522 75.6603 185.216 72.9353 189.516 71.9361L217.178 66.0775H241.025L267.309 71.8756C271.882 72.9202 275.758 75.9025 277.953 80.0353L299.574 120.91Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M270.156 120.289L262.54 105.256"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M191.787 121.697L199.327 106.816"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M160.84 80.6865L178.115 102.774"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M232.077 73.3438L238.436 81.0797L252.669 68.999"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M227.216 73.4952L221.039 81.3825L205.398 68.999"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M149.893 66.7588C151.331 68.9539 146.728 74.9186 139.582 79.657C132.557 84.3197 125.107 86.5602 123.487 84.5468"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M145.139 70.5888C146.084 70.5888 146.85 69.8229 146.85 68.8782C146.85 67.9334 146.084 67.1675 145.139 67.1675C144.194 67.1675 143.428 67.9334 143.428 68.8782C143.428 69.8229 144.194 70.5888 145.139 70.5888Z"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M229.624 81.3374C230.569 81.3374 231.335 80.5715 231.335 79.6267C231.335 78.6819 230.569 77.916 229.624 77.916C228.679 77.916 227.913 78.6819 227.913 79.6267C227.913 80.5715 228.679 81.3374 229.624 81.3374Z"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M229.624 95.1137C230.569 95.1137 231.335 94.3478 231.335 93.4031C231.335 92.4583 230.569 91.6924 229.624 91.6924C228.679 91.6924 227.913 92.4583 227.913 93.4031C227.913 94.3478 228.679 95.1137 229.624 95.1137Z"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M185.564 130.644L192.393 120.91V130.644H185.564Z"
            fill="#06D6A0"
          />
          <path
            d="M134.207 72.2843C127.212 76.8864 119.868 79.1118 118.264 77.1135C118.233 77.0832 118.218 77.0529 118.188 77.0075C117.855 76.508 117.885 75.8267 118.188 74.9941C119.233 72.254 123.548 68.0151 129.029 64.4121C133.389 61.5358 137.689 59.5375 140.672 58.9168C142.398 58.5686 143.685 58.6746 144.306 59.3407L144.457 59.5223C145.88 61.7023 141.308 67.6064 134.207 72.2843Z"
            fill="#FE5244"
          />
          <path
            d="M134.207 72.2843C130.225 74.9033 126.122 76.7653 123.033 77.492L109.21 57.9933C107.287 55.2684 107.923 51.4988 110.663 49.5762L123.109 40.826L116.053 28.821C115.024 27.0801 115.614 24.8244 117.371 23.8101C117.946 23.4771 118.567 23.3257 119.187 23.3257C120.384 23.3257 121.565 23.9161 122.261 25.0061L144.321 59.3104L144.472 59.5526C145.881 61.7023 141.308 67.6064 134.207 72.2843Z"
            fill="#E57281"
          />
          <path
            d="M123.079 40.9624L130.786 52.9068C131.497 54.0271 131.179 55.5107 130.059 56.2374L128.348 57.3576C127.228 58.0994 125.714 57.7815 124.987 56.6612L117.704 45.7614"
            stroke="#9A3B82"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M124.956 56.6309C125.698 57.7663 125.365 59.2953 124.229 60.0219L122.67 61.0059C121.549 61.7175 120.066 61.3996 119.339 60.2944"
            stroke="#9A3B82"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M112.177 49.6064L119.309 60.2035C120.051 61.3389 119.733 62.868 118.567 63.5946L117.113 64.397C116.023 65.0933 114.585 64.8057 113.828 63.746L109.694 57.9176"
            stroke="#9A3B82"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M139.173 51.317L135.555 45.7005C134.358 43.8384 131.86 43.3237 130.028 44.5651L121.05 50.6509C121.05 50.6509 123.654 55.3287 129.983 51.6197L132.103 54.9957C127.772 57.7358 126.531 63.5036 129.347 67.7879L139.173 51.317Z"
            fill="#E57281"
          />
          <path
            d="M138.704 51.4683L135.085 45.8519C133.889 43.9898 131.391 43.4751 129.559 44.7165L121.05 50.6508C121.05 50.6508 123.654 55.3287 129.983 51.6197L132.103 54.9957C127.772 57.7358 126.531 63.5036 129.347 67.7879"
            stroke="#9A3B82"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M134.207 72.2842C130.225 74.9032 126.122 76.7653 123.034 77.492L119.597 72.6476C121.52 70.1346 124.956 67.1068 129.029 64.4273C133.39 61.5509 137.69 59.5526 140.673 58.9319C142.399 58.5837 143.686 58.6897 144.306 59.3558L144.458 59.5375C144.473 59.5677 144.488 59.5829 144.503 59.6132C144.518 59.6283 144.518 59.6434 144.533 59.6737C144.549 59.704 144.564 59.7191 144.579 59.7494C145.608 62.0656 141.081 67.7426 134.207 72.2842Z"
            fill="#9A3B82"
          />
          <path
            d="M241.01 52.7554V66.0623C241.01 69.9227 235.65 73.0412 229.064 73.0412C222.463 73.0412 217.118 69.9227 217.118 66.0623V52.7554H241.01Z"
            fill="#E57281"
          />
          <path
            d="M220.615 70.9975C218.45 69.741 217.103 67.9849 217.103 66.0623V52.7554H241.01V56.4492C241.01 60.2793 238.678 63.7158 235.135 65.154L220.615 70.9975Z"
            fill="#9A3B82"
          />
          <path
            d="M247.671 51.9677V52.1948C247.671 54.4959 245.809 56.3579 243.508 56.3579H240.767C239.844 60.0821 236.482 62.8524 232.455 62.8524H225.672C221.66 62.8524 218.283 60.0972 217.375 56.3579H214.634C212.333 56.3579 210.471 54.4959 210.471 52.1948V51.9677C210.471 49.6666 212.333 47.8046 214.634 47.8046H217.117V44.5195C217.117 41.0073 219.707 38.1006 223.083 37.6162C223.825 38.8576 226.066 41.8248 230.638 41.6582C232.788 41.5825 234.787 41.1738 236.437 40.6894C238.42 40.1141 240.404 41.3252 240.904 43.2175C240.979 43.6414 241.025 44.0653 241.025 44.5043V47.7894H243.508C245.794 47.7894 247.671 49.6666 247.671 51.9677Z"
            fill="#E57281"
          />
          <path
            d="M242.918 47.7897H241.01V44.1412C241.01 43.8233 240.965 43.5054 240.889 43.2178C240.389 41.3254 238.406 40.1143 236.422 40.6896C234.772 41.174 232.789 41.5828 230.623 41.6585C226.051 41.825 223.81 38.8578 223.068 37.6164C219.692 38.1009 217.103 41.0075 217.103 44.5197V47.8048H214.726C214.726 47.8048 212 37.9495 214.044 35.164C216.058 32.4239 218.481 33.6198 218.481 33.6198C218.481 33.6198 217.027 25.4146 225.142 25.566C233.243 25.7174 243.781 35.1186 244.553 36.8444C245.764 39.4936 242.918 47.7897 242.918 47.7897Z"
            fill="#9A3B82"
          />
          <path
            d="M241.933 52.7396C241.933 51.1198 243.25 49.8179 244.855 49.8179"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M216.224 52.7396C216.224 51.1198 214.907 49.8179 213.302 49.8179"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M237.194 44.5195C237.194 44.5195 235.044 42.945 232.304 44.0804"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M220.781 44.5195C220.781 44.5195 222.931 42.945 225.672 44.0804"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M232.833 55.6919C232.833 55.6919 231.667 58.2049 228.094 56.8879"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M227.928 54.3896C228.851 54.4502 230.259 54.3896 230.259 54.3896"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M234.756 50.8324C235.174 50.8324 235.513 50.263 235.513 49.5607C235.513 48.8584 235.174 48.2891 234.756 48.2891C234.338 48.2891 233.999 48.8584 233.999 49.5607C233.999 50.263 234.338 50.8324 234.756 50.8324Z"
            fill="#9A3B82"
          />
          <path
            d="M223.901 50.8324C224.319 50.8324 224.658 50.263 224.658 49.5607C224.658 48.8584 224.319 48.2891 223.901 48.2891C223.482 48.2891 223.144 48.8584 223.144 49.5607C223.144 50.263 223.482 50.8324 223.901 50.8324Z"
            fill="#9A3B82"
          />
          <path
            d="M225.702 53.8453H220.933C220.009 53.8453 219.268 53.1035 219.268 52.18V47.4114C219.268 46.4879 220.009 45.7461 220.933 45.7461H225.702C226.626 45.7461 227.368 46.4879 227.368 47.4114V52.18C227.383 53.0884 226.626 53.8453 225.702 53.8453Z"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M237.376 53.8453H232.607C231.683 53.8453 230.941 53.1035 230.941 52.18V47.4114C230.941 46.4879 231.683 45.7461 232.607 45.7461H237.376C238.3 45.7461 239.042 46.4879 239.042 47.4114V52.18C239.042 53.0884 238.3 53.8453 237.376 53.8453Z"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M227.383 48.895H230.941"
            stroke="white"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M238.633 115.036H222.084C220.585 115.036 219.358 113.825 219.358 112.311V103.515C219.358 102.017 220.57 100.791 222.084 100.791H238.633C240.131 100.791 241.358 102.002 241.358 103.515V112.311C241.358 113.81 240.147 115.036 238.633 115.036Z"
            stroke="#66B0F0"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M230.775 111.494H225.173C224.279 111.494 223.553 110.767 223.553 109.874V105.953C223.553 105.06 224.279 104.333 225.173 104.333H230.775C231.668 104.333 232.395 105.06 232.395 105.953V109.874C232.395 110.767 231.668 111.494 230.775 111.494Z"
            fill="#66B0F0"
          />
          <path
            d="M236.225 111.388L234.499 110.237C234.03 109.919 233.742 109.374 233.742 108.784V107.058C233.742 106.468 234.03 105.923 234.499 105.605L236.225 104.454C236.634 104.182 237.164 104.485 237.164 104.999V110.858C237.179 111.358 236.634 111.66 236.225 111.388Z"
            fill="#66B0F0"
          />
          <path
            d="M459.96 164.585H58.0195"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M187.428 167.235V354.137H176.874V318.561C176.874 315.246 174.179 312.551 170.864 312.551H95.3266C92.0108 312.551 89.3158 315.246 89.3158 318.561V354.137H78.7627V167.235H187.428Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M187.745 167.235V216.829L78.7627 306.556L78.7778 167.235H187.745Z"
            fill="#D0F0E4"
          />
          <path
            d="M176.875 181.465V215.361C176.875 218.51 174.331 221.053 171.182 221.053H95.024C91.8747 221.053 89.3311 218.51 89.3311 215.361V181.465C89.3311 178.316 91.8747 175.773 95.024 175.773H171.182C174.331 175.773 176.875 178.316 176.875 181.465Z"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M152.468 246.728H114.979L113.42 235.995H150.923L152.468 246.728Z"
            fill="#FFCF2D"
          />
          <path
            d="M172.469 229.803C167.79 229.803 164.005 233.588 164.005 238.266V246.728H132.104V238.266C132.104 233.588 135.889 229.803 140.567 229.803H172.469Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M180.418 235.995H148.516C147.532 232.422 144.247 229.803 140.355 229.803H172.257C176.148 229.803 179.418 232.422 180.418 235.995Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M176.875 252.42V286.316C176.875 289.465 174.331 292.008 171.182 292.008H95.024C91.8747 292.008 89.3311 289.465 89.3311 286.316V252.42C89.3311 249.271 91.8747 246.728 95.024 246.728H171.182C174.331 246.728 176.875 249.271 176.875 252.42Z"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M117.508 197.739C117.508 195.045 119.688 192.85 122.398 192.85H143.822C146.517 192.85 148.713 195.03 148.713 197.739"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M117.508 268.694C117.508 266 119.688 263.805 122.398 263.805H143.822C146.517 263.805 148.713 265.985 148.713 268.694"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M443.956 167.235H432.706V354.546H443.956V167.235Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M252.774 354.546H487.546"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M110.709 138.895H103.91C103.91 138.895 94.2053 98.4595 85.6811 97.1424C77.1569 95.8254 76.7178 111.388 76.7178 111.388C76.7178 111.388 76.8692 87.7262 98.1722 90.9658C119.49 94.2055 110.709 138.895 110.709 138.895Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M87.4229 91.9951C87.4229 91.9951 106.848 84.8194 107.727 138.289"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M129.226 138.29H97.2939V164.283H129.226V138.29Z"
            fill="#FE5244"
          />
          <path
            d="M135.949 151.294C133.92 152.172 131.497 152.066 129.241 151.082C127.576 150.355 126.001 149.159 124.729 147.524C122.973 145.253 121.792 142.15 121.792 138.29C121.792 128.934 114.343 123.06 111.284 135.444C111.072 136.306 110.876 137.245 110.709 138.29V138.259V138.199C110.709 138.169 110.709 138.123 110.724 138.078V138.017C110.785 137.245 111.012 134.959 111.708 132.204C112.223 130.16 112.995 127.889 114.146 125.785C114.721 124.741 115.387 123.741 116.175 122.848C118.204 120.517 120.99 118.882 124.79 118.882C131.785 118.882 136.902 127.117 138.856 135.322C140.566 142.453 139.87 149.583 135.949 151.294Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M116.189 122.848C116.189 122.848 130.21 112.872 134.328 151.581"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M76.2637 111.388C76.2637 113.886 75.976 123.439 85.0907 123.878C94.2054 124.317 95.1139 110.555 95.1139 110.555C95.1139 110.555 90.6322 98.3839 85.6812 97.1426C77.3084 95.0383 76.2637 111.388 76.2637 111.388Z"
            fill="#06D6A0"
          />
          <path
            d="M121.792 138.289H110.709C113.268 122.257 121.792 128.283 121.792 138.289Z"
            fill="#06D6A0"
          />
          <path
            opacity="0.4"
            d="M310.006 20.5403V120.471C310.006 125.845 305.645 130.19 300.285 130.19H185.897C178.721 140.076 163.928 140.121 156.691 130.19L156.676 130.175C153.799 129.978 151.255 128.51 149.62 126.345L152.255 124.074L219.479 66.0624L283.494 10.8213H300.285C305.645 10.8213 310.006 15.1812 310.006 20.5403Z"
            fill="white"
          />
          <path
            opacity="0.4"
            d="M135.948 151.748C133.935 152.656 131.497 152.52 129.241 151.536V164.283H105.667L124.744 147.827L129.256 143.936L132.693 140.969L139.34 135.322C141.278 143.588 140.203 149.795 135.948 151.748Z"
            fill="white"
          />
          <path
            d="M11.8703 25.0523C11.6886 25.0523 11.5069 24.9312 11.4464 24.7496C11.3707 24.5073 11.4918 24.25 11.7189 24.1743L13.1421 23.6747C13.3844 23.599 13.6418 23.7201 13.7175 23.9472C13.7932 24.1894 13.672 24.4468 13.4449 24.5225L12.0217 25.0221C11.9611 25.0372 11.9157 25.0523 11.8703 25.0523ZM15.4435 23.811C15.2618 23.811 15.0801 23.6899 15.0196 23.5082C14.9439 23.266 15.065 23.0086 15.2921 22.9329L16.7153 22.4333C16.9576 22.3576 17.215 22.4788 17.2907 22.7058C17.3664 22.9481 17.2452 23.2054 17.0181 23.2811L15.5949 23.7807C15.5495 23.7958 15.4889 23.811 15.4435 23.811ZM19.0167 22.5545C18.835 22.5545 18.6533 22.4333 18.5928 22.2517C18.5171 22.0095 18.6382 21.7521 18.8653 21.6764L20.2885 21.1768C20.5308 21.1011 20.7882 21.2222 20.8639 21.4493C20.9396 21.6915 20.8185 21.9489 20.5913 22.0246L19.1681 22.5242C19.1227 22.5545 19.0621 22.5545 19.0167 22.5545ZM22.5899 21.3131C22.4082 21.3131 22.2265 21.192 22.166 21.0103C22.0903 20.7681 22.2114 20.5107 22.4385 20.435L23.8617 19.9355C24.104 19.8598 24.3614 19.9809 24.4371 20.208C24.5128 20.4502 24.3917 20.7075 24.1646 20.7832L22.7413 21.2828C22.6959 21.3131 22.6505 21.3131 22.5899 21.3131ZM26.1631 20.0717C25.9814 20.0717 25.7997 19.9506 25.7392 19.7689C25.6635 19.5267 25.7846 19.2694 26.0117 19.1937L27.4349 18.6941C27.6772 18.6184 27.9346 18.7395 28.0103 18.9666C28.086 19.2088 27.9649 19.4662 27.7378 19.5419L26.3145 20.0414C26.2691 20.0717 26.2237 20.0717 26.1631 20.0717ZM29.7515 18.8303C29.5698 18.8303 29.3881 18.7092 29.3275 18.5276C29.2518 18.2853 29.373 18.028 29.6001 17.9523L31.0233 17.4527C31.2655 17.377 31.5229 17.4981 31.5986 17.7252C31.6743 17.9674 31.5532 18.2248 31.3261 18.3005L29.9029 18.8001C29.8423 18.8303 29.7969 18.8303 29.7515 18.8303ZM33.3247 17.589C33.143 17.589 32.9613 17.4678 32.9007 17.2862C32.825 17.044 32.9462 16.7866 33.1733 16.7109L34.5965 16.2113C34.8387 16.1356 35.0961 16.2568 35.1718 16.4838C35.2475 16.7261 35.1264 16.9834 34.8993 17.0591L33.4761 17.5587C33.4155 17.5738 33.3701 17.589 33.3247 17.589ZM36.8979 16.3476C36.7162 16.3476 36.5345 16.2265 36.4739 16.0448C36.3982 15.8026 36.5194 15.5452 36.7465 15.4695L38.1697 14.97C38.412 14.8943 38.6693 15.0154 38.745 15.2425C38.8208 15.4847 38.6996 15.742 38.4725 15.8177L37.0493 16.3173C36.9887 16.3324 36.9433 16.3476 36.8979 16.3476ZM40.4711 15.1062C40.2894 15.1062 40.1077 14.9851 40.0471 14.8034C39.9714 14.5612 40.0926 14.3039 40.3197 14.2282L41.7429 13.7286C41.9852 13.6529 42.2425 13.774 42.3183 14.0011C42.394 14.2433 42.2728 14.5007 42.0457 14.5764L40.6225 15.0759C40.5771 15.0911 40.5165 15.1062 40.4711 15.1062ZM44.0443 13.8648C43.8626 13.8648 43.6809 13.7437 43.6204 13.5621C43.5447 13.3198 43.6658 13.0625 43.8929 12.9868L45.3161 12.4872C45.5584 12.4115 45.8158 12.5326 45.8915 12.7597C45.9672 13.0019 45.846 13.2593 45.6189 13.335L44.1957 13.8346C44.1503 13.8497 44.0897 13.8648 44.0443 13.8648ZM47.6175 12.6235C47.4358 12.6235 47.2541 12.5024 47.1936 12.3207C47.1179 12.0785 47.239 11.8211 47.4661 11.7454L48.8893 11.2458C49.1316 11.1701 49.389 11.2913 49.4647 11.5183C49.5404 11.7606 49.4192 12.0179 49.1921 12.0936L47.7689 12.5932C47.7235 12.6083 47.6629 12.6235 47.6175 12.6235ZM51.1907 11.367C51.009 11.367 50.8273 11.2458 50.7668 11.0642C50.6911 10.822 50.8122 10.5646 51.0393 10.4889L52.4625 9.98933C52.7048 9.91363 52.9622 10.0347 53.0379 10.2618C53.1136 10.504 52.9924 10.7614 52.7653 10.8371L51.3421 11.3367C51.2967 11.3669 51.2513 11.367 51.1907 11.367ZM54.7639 10.1256C54.5822 10.1256 54.4005 10.0045 54.34 9.8228C54.2643 9.58058 54.3854 9.32323 54.6125 9.24753L56.0357 8.74795C56.278 8.67226 56.5354 8.79337 56.6111 9.02045C56.6868 9.26267 56.5657 9.52003 56.3385 9.59572L54.9153 10.0953C54.8699 10.1256 54.8245 10.1256 54.7639 10.1256ZM58.3523 8.8842C58.1706 8.8842 57.9889 8.76309 57.9283 8.58143C57.8526 8.33921 57.9737 8.08185 58.2008 8.00616L59.6241 7.50658C59.8663 7.43089 60.1237 7.552 60.1994 7.77908C60.2751 8.02129 60.154 8.27865 59.9269 8.35434L58.5037 8.85392C58.4431 8.8842 58.3977 8.8842 58.3523 8.8842ZM61.9255 7.64283C61.7438 7.64283 61.5621 7.52172 61.5015 7.34005C61.4258 7.09783 61.5469 6.84047 61.7741 6.76478L63.1973 6.2652C63.4395 6.18951 63.6969 6.31062 63.7726 6.5377C63.8483 6.77992 63.7272 7.03728 63.5001 7.11297L62.0769 7.61255C62.0163 7.64283 61.9709 7.64283 61.9255 7.64283ZM65.4987 6.40145C65.317 6.40145 65.1353 6.28034 65.0747 6.09868C64.999 5.85646 65.1202 5.5991 65.3473 5.52341L66.7705 5.02383C67.0127 4.94814 67.2701 5.06925 67.3458 5.29633C67.4215 5.53855 67.3004 5.7959 67.0733 5.8716L65.6501 6.37118C65.5895 6.40146 65.5441 6.40145 65.4987 6.40145ZM69.0719 5.16008C68.8902 5.16008 68.7085 5.03897 68.6479 4.85731C68.5722 4.61509 68.6934 4.35773 68.9205 4.28203L70.3437 3.78246C70.5859 3.70676 70.8433 3.82787 70.919 4.05495C70.9947 4.29717 70.8736 4.55453 70.6465 4.63023L69.2233 5.1298C69.1779 5.14494 69.1173 5.16008 69.0719 5.16008ZM72.6451 3.91871C72.4634 3.91871 72.2817 3.7976 72.2211 3.61593C72.1454 3.37371 72.2666 3.11636 72.4937 3.04066L73.9169 2.54108C74.1592 2.46539 74.4165 2.5865 74.4922 2.81358C74.5679 3.0558 74.4468 3.31316 74.2197 3.38885L72.7965 3.88843C72.7511 3.90357 72.6905 3.91871 72.6451 3.91871Z"
            fill="#FFCF2D"
          />
          <path
            d="M27.9797 25.0522C27.7223 25.0522 27.5255 24.8554 27.5255 24.5981C27.5255 20.4955 26.2536 17.5131 23.7251 15.757C21.8326 14.44 19.9097 14.3189 19.8945 14.3189C19.6372 14.3037 19.4555 14.0918 19.4706 13.8344C19.4857 13.5771 19.6977 13.3954 19.94 13.4105C20.0308 13.4105 22.1051 13.5317 24.2096 14.985C27.7071 17.4072 28.4339 21.5552 28.4339 24.5981C28.4339 24.8403 28.2371 25.0522 27.9797 25.0522Z"
            fill="#06D6A0"
          />
          <path
            d="M100.322 25.0522H11.8702C11.7036 25.0522 11.5371 24.9614 11.4614 24.7949C11.3857 24.6435 11.4008 24.4618 11.5068 24.3256L47.4508 -23.5884C47.5265 -23.6944 47.6477 -23.7549 47.7688 -23.7701C47.8899 -23.7852 48.0262 -23.7398 48.117 -23.649L100.64 24.265C100.776 24.3861 100.822 24.5829 100.761 24.7646C100.686 24.9311 100.519 25.0522 100.322 25.0522ZM12.7786 24.1439H99.1563L47.8748 -22.6498L12.7786 24.1439Z"
            fill="#06D6A0"
          />
          <path
            d="M3.92144 28.2007C1.75632 28.2007 0 26.4446 0 24.2798C0 22.115 1.75632 20.3589 3.92144 20.3589C6.08656 20.3589 7.84288 22.115 7.84288 24.2798C7.84288 26.4446 6.08656 28.2007 3.92144 28.2007ZM3.92144 21.2521C2.25596 21.2521 0.908442 22.5994 0.908442 24.2647C0.908442 25.9299 2.25596 27.2773 3.92144 27.2773C5.58692 27.2773 6.93444 25.9299 6.93444 24.2647C6.93444 22.5994 5.58692 21.2521 3.92144 21.2521Z"
            fill="#FFCF2D"
          />
          <path
            d="M7.84301 24.2798H6.93457V27.7465H7.84301V24.2798Z"
            fill="#FFCF2D"
          />
          <path
            d="M107.393 28.1099C105.228 28.1099 103.472 26.3538 103.472 24.189C103.472 22.0242 105.228 20.2681 107.393 20.2681V21.1764C105.728 21.1764 104.38 22.5237 104.38 24.189C104.38 25.8542 105.728 27.2016 107.393 27.2016V28.1099Z"
            fill="#FFCF2D"
          />
          <path
            d="M336.699 219.009V303.271H317.228L304.827 268.649L287.067 219.009H336.699Z"
            fill="#A0505A"
          />
          <path
            d="M287.067 219.009H336.699V246.062L292.972 235.495L287.067 219.009Z"
            fill="#73325A"
          />
          <path
            d="M336.698 268.649V303.271H317.227L304.827 268.649C304.827 268.649 314.865 274.19 336.698 268.649Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M314.957 276.778C316.177 276.778 317.167 275.789 317.167 274.568C317.167 273.347 316.177 272.358 314.957 272.358C313.736 272.358 312.746 273.347 312.746 274.568C312.746 275.789 313.736 276.778 314.957 276.778Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M325.494 283.909C326.715 283.909 327.704 282.919 327.704 281.699C327.704 280.478 326.715 279.488 325.494 279.488C324.273 279.488 323.283 280.478 323.283 281.699C323.283 282.919 324.273 283.909 325.494 283.909Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M333.338 275.991C334.558 275.991 335.548 275.002 335.548 273.781C335.548 272.56 334.558 271.571 333.338 271.571C332.117 271.571 331.127 272.56 331.127 273.781C331.127 275.002 332.117 275.991 333.338 275.991Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M330.233 292.205C331.454 292.205 332.444 291.215 332.444 289.994C332.444 288.774 331.454 287.784 330.233 287.784C329.012 287.784 328.022 288.774 328.022 289.994C328.022 291.215 329.012 292.205 330.233 292.205Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M317.167 288.178C318.387 288.178 319.377 287.188 319.377 285.968C319.377 284.747 318.387 283.757 317.167 283.757C315.946 283.757 314.956 284.747 314.956 285.968C314.956 287.188 315.946 288.178 317.167 288.178Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M320.77 300.289C321.991 300.289 322.981 299.299 322.981 298.078C322.981 296.858 321.991 295.868 320.77 295.868C319.549 295.868 318.56 296.858 318.56 298.078C318.56 299.299 319.549 300.289 320.77 300.289Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M345.904 318.985L332.55 346.704C330.657 351.17 326.282 354.077 321.422 354.077H304.388C300.028 354.077 297.378 349.656 299.044 345.63L316.168 304.331C317.122 301.818 318.802 299.729 320.907 298.261C323.027 296.792 325.57 295.959 328.25 295.959C331.975 295.959 335.669 298.488 338.122 301.288L344.057 307.692C346.797 310.811 347.509 315.186 345.904 318.985Z"
            fill="#3A86FF"
          />
          <path
            d="M345.905 318.985L332.551 346.704C330.658 351.17 326.282 354.077 321.422 354.077H303.314C301.633 354.077 300.679 353.032 300.119 351.594H304.147C309.007 351.594 313.382 348.688 315.275 344.222L330.673 312.112C332.111 309.115 335.155 307.192 338.486 307.192C342.831 307.192 346.132 310.371 346.737 314.398C346.798 315.943 346.525 317.502 345.905 318.985Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M342.83 306.36C341.226 305.482 339.288 304.846 337.592 304.846C334.337 304.846 331.324 306.738 329.915 309.675L313.972 342.92C311.943 347.719 307.25 350.822 302.026 350.822H299.089C298.938 350.534 298.832 350.232 298.726 349.914H302.026C306.886 349.914 311.247 347.022 313.14 342.556L313.155 342.541L329.113 309.281C330.672 306.027 334.003 303.938 337.607 303.938C338.758 303.938 340.135 304.316 341.316 304.725L342.83 306.36Z"
            fill="white"
          />
          <path
            d="M287.068 219.009L283.267 268.649L281.571 290.888C281.571 290.888 270.504 303.211 257.907 295.611L252.077 268.664L238.738 207.004C235.135 190.336 246.521 174.123 263.433 171.867L287.068 219.009Z"
            fill="#A0505A"
          />
          <path
            d="M283.267 268.649L281.571 291.493C281.571 291.493 270.503 303.816 257.906 296.217L252.077 268.664C266.718 273.054 283.267 268.649 283.267 268.649Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M265.871 282.379C267.092 282.379 268.081 281.39 268.081 280.169C268.081 278.949 267.092 277.959 265.871 277.959C264.65 277.959 263.66 278.949 263.66 280.169C263.66 281.39 264.65 282.379 265.871 282.379Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M279.921 278.989C281.141 278.989 282.131 277.999 282.131 276.779C282.131 275.558 281.141 274.568 279.921 274.568C278.7 274.568 277.71 275.558 277.71 276.779C277.71 277.999 278.7 278.989 279.921 278.989Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M257.391 275.991C258.612 275.991 259.602 275.002 259.602 273.781C259.602 272.56 258.612 271.571 257.391 271.571C256.17 271.571 255.181 272.56 255.181 273.781C255.181 275.002 256.17 275.991 257.391 275.991Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M263.66 294.415C264.881 294.415 265.87 293.426 265.87 292.205C265.87 290.984 264.881 289.995 263.66 289.995C262.439 289.995 261.449 290.984 261.449 292.205C261.449 293.426 262.439 294.415 263.66 294.415Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M273.97 289.995C275.191 289.995 276.181 289.005 276.181 287.784C276.181 286.564 275.191 285.574 273.97 285.574C272.749 285.574 271.76 286.564 271.76 287.784C271.76 289.005 272.749 289.995 273.97 289.995Z"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M296.167 296.186L281.572 354.546H276.969C276.757 354.546 276.56 354.531 276.348 354.516C272.866 354.198 269.928 351.261 269.187 347.794L257.892 295.581C270.489 303.195 281.572 290.873 281.572 290.873L296.167 296.186Z"
            fill="#3A86FF"
          />
          <path
            d="M296.909 326.131C299.983 309.902 300.831 297.503 295.531 296.504C290.232 295.505 280.8 306.269 277.726 322.497C274.652 338.726 276.257 353.077 281.557 354.077C286.856 355.091 293.836 342.374 296.909 326.131Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M275.606 322.24C274.016 330.657 273.547 338.787 274.304 345.145C274.849 349.717 275.999 352.972 277.574 354.546H276.968C276.756 354.546 276.56 354.531 276.348 354.516C274.924 352.639 273.91 349.49 273.395 345.251C272.623 338.817 273.092 330.581 274.712 322.074C276.242 314.02 279.33 306.466 283.433 300.788C285.886 297.397 288.46 295.021 290.807 293.946L292.17 294.4C286.764 296.005 278.558 306.662 275.606 322.24Z"
            fill="white"
          />
          <path
            d="M263.434 171.852L332.505 164.737L401.547 184.099L400.957 193.273C400.018 207.746 387.542 219.009 373.037 219.009H287.083L263.434 171.852Z"
            fill="#FE5244"
          />
          <path
            d="M397.61 183.433C397.61 196.574 384.499 212.651 369.994 212.651H284.04"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M389.419 180.814C387.269 192.547 375.793 205.082 363.226 205.082H280.558"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M380.108 178.029C376.474 187.99 366.618 197.361 355.943 197.361H276.167"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M372.946 176.076C368.177 183.327 360.349 189.034 352.007 189.034H272.23"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M364.952 173.835C360.364 178.453 354.429 181.465 348.222 181.465H268.445"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M354.551 170.823C351.31 172.655 347.768 173.745 344.134 173.745H264.357"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M286.917 219.009L263.282 171.852"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M405.332 120.911C398.821 122.758 392.417 122.213 391.735 120.23C391.099 118.337 393.976 115.098 399.805 112.948C400.093 112.842 400.396 112.736 400.698 112.63C402.455 112.04 404.211 111.661 405.861 111.464C410.752 110.844 414.734 111.722 415.234 113.205C415.915 115.188 412.221 118.958 405.332 120.911Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M401.213 165.055H398.715L392.159 120.805V120.775L391.992 119.67C392.31 117.656 395.459 114.81 401.016 112.963C403.787 112.04 406.542 111.631 408.889 111.585L411.281 118.141L411.509 118.761L419.079 139.516C423.621 151.915 414.431 165.055 401.213 165.055Z"
            fill="#A0505A"
          />
          <path
            d="M411.433 118.61C409.843 119.609 407.784 120.532 405.331 121.229C399.699 122.818 393.991 122.167 392.159 120.805V120.775L391.992 119.67C392.31 117.656 395.459 114.81 401.016 112.963C403.787 112.04 406.542 111.631 408.889 111.585L411.433 118.61Z"
            fill="#73325A"
          />
          <path
            d="M320.12 128.647L312.171 148.418C308.25 158.182 298.772 164.586 288.234 164.586H181.386V154.806C181.386 152.445 182.839 150.325 185.05 149.493L196.027 145.329C197.026 144.951 198.071 144.754 199.131 144.754H211.591L282.117 137.639L294.29 109.769L320.12 128.647Z"
            fill="#A0505A"
          />
          <path
            d="M192.893 151.339L184.611 154.473C182.945 155.109 181.84 156.698 181.84 158.485"
            stroke="#73325A"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M192.893 156.335L184.611 159.469C182.945 160.105 181.84 161.695 181.84 163.481"
            stroke="#73325A"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M192.892 161.149L184.61 164.132"
            stroke="#73325A"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M192.029 147.01C192.029 147.01 199.781 127.223 202.264 127.556C204.747 127.889 195.391 145.738 195.391 145.738L192.029 147.01Z"
            fill="#FE5244"
          />
          <path
            d="M294.29 109.784L292.503 113.856L315.381 140.424L320.12 128.647L294.29 109.784Z"
            fill="#73325A"
          />
          <path
            d="M392.159 120.82L401.546 184.1L332.52 164.737L320.12 128.631L288.112 105.242L299.347 91.8594C309.37 79.915 324.162 73.0117 339.757 73.0117H361.938C381.228 73.0117 398.988 83.5483 408.239 100.473L415.43 112.917C415.43 112.917 413.265 109.738 401.592 112.932C391.311 115.763 392.159 120.82 392.159 120.82Z"
            fill="#06D6A0"
          />
          <path
            d="M320.12 128.344L323.708 112.781"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M399.805 169.324L388.132 96.7642"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M332.505 164.45L401.395 184.1"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M336.229 62.899V73.0722L354.186 72.9208V54.9663L336.229 62.899Z"
            fill="#A0505A"
          />
          <path
            d="M355.64 51.8327V52.1052C355.64 54.8302 353.581 57.0404 350.855 57.0404H349.795C349.114 59.7351 343.058 62.884 338.758 62.884H333.746C328.265 62.884 324.071 57.9639 324.965 52.5442L325.207 51.0758L323.723 50.2431C322.875 49.7587 322.633 48.6536 323.223 47.8664L326.433 43.6275L327.13 39.4492C327.69 36.0128 329.946 33.2121 332.944 31.8345C334.125 45.1414 345.874 46.7158 348.978 46.8975H350.704C353.429 46.8975 355.64 49.1077 355.64 51.8327Z"
            fill="#A0505A"
          />
          <path
            d="M347.69 53.1348C347.69 50.9851 349.432 49.2441 351.582 49.2441"
            stroke="#73325A"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M331.278 47.0337C331.705 47.0337 332.05 46.2339 332.05 45.2473C332.05 44.2607 331.705 43.4609 331.278 43.4609C330.852 43.4609 330.506 44.2607 330.506 45.2473C330.506 46.2339 330.852 47.0337 331.278 47.0337Z"
            fill="#73325A"
          />
          <path
            d="M330.098 39.7219C330.098 39.7219 332.233 39.51 334.428 42.5377"
            stroke="#73325A"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M348.978 46.8973H350.704C353.429 46.8973 355.64 49.1075 355.64 51.8325V52.105C355.64 54.8299 353.581 57.0402 350.855 57.0402L349.69 57.8577C344.784 61.0065 338.001 73.39 339.666 82.1553C341.544 92.0106 350.129 94.2057 358.062 92.6919C365.996 91.178 371.78 86.5607 369.902 76.6902C369.69 75.5246 369.342 74.3589 368.903 73.2083C369.039 73.2538 369.161 73.2992 369.297 73.3446C378.835 75.9484 390.04 76.2512 393.128 68.803C396.217 61.3547 395.52 53.9822 386.239 50.1369C380.849 47.8964 373.521 47.9116 367.843 49.4557C370.705 39.5096 365.618 28.4432 356.276 27.3381C341.604 25.5971 333.186 31.6526 332.959 31.8191C332.944 33.5752 334.14 46.0344 348.978 46.8973Z"
            fill="#73325A"
          />
          <path
            d="M368.222 49.1074C367.026 52.9981 364.558 57.1612 360.546 59.9922C360.546 59.9922 367.632 64.67 369.297 73.3596"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M372.339 48.7745H368.327V44.7627C368.327 42.6584 370.023 40.9629 372.127 40.9629H372.339C374.444 40.9629 376.14 42.6584 376.14 44.7627V44.9746C376.155 47.0638 374.444 48.7745 372.339 48.7745Z"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M370.871 52.892L368.297 48.8045L372.385 46.231C374.429 44.9442 377.139 45.5497 378.426 47.5935L378.668 47.9719C379.955 50.0156 379.35 52.7255 377.306 54.0123L376.927 54.2545C374.853 55.5413 372.158 54.9357 370.871 52.892Z"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M347.161 60.1888L350.023 57.4487L352.824 60.6127C354.201 62.2023 354.02 64.6093 352.43 65.9718L352.263 66.1081C350.674 67.4857 348.266 67.304 346.904 65.7145L346.767 65.5479C345.389 63.9735 345.571 61.5665 347.161 60.1888Z"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M351.34 62.157L350.053 57.5094L354.701 56.2226C357.033 55.5717 359.44 56.9341 360.091 59.2655L360.212 59.7045C360.863 62.0359 359.501 64.4429 357.169 65.0939L356.73 65.215C354.398 65.8508 351.991 64.4732 351.34 62.157Z"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M310.022 230.651L283.646 354.077"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M377.519 230.651L403.894 354.077"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M289.491 326.676H397.687"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M398.276 230.651H289.248C287.87 230.651 286.75 229.531 286.75 228.153V221.507C286.75 220.13 287.87 219.009 289.248 219.009H398.276C399.654 219.009 400.775 220.13 400.775 221.507V228.153C400.775 229.531 399.654 230.651 398.276 230.651Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_362_716">
            <rect
              width="488"
              height="394"
              fill="white"
              transform="translate(0 -39)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    icon: (
      <svg
        width="653"
        height="435"
        viewBox="0 0 653 435"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_362_919)">
          <path
            d="M653 434.843H0L117.219 365.6H537.575L653 434.843Z"
            fill="#D0F0E4"
          />
          <path
            d="M374.395 96.3279H256.914V28.3738C256.914 23.7727 260.643 20.043 265.242 20.043H366.067C370.666 20.043 374.395 23.7727 374.395 28.3738V96.3279Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M365.527 91.9008H266.27C263.657 91.9008 261.531 89.7745 261.531 87.1602V28.9139C261.531 26.2996 263.657 24.1733 266.27 24.1733H365.527C368.14 24.1733 370.266 26.2996 370.266 28.9139V87.1777C370.266 89.792 368.14 91.9008 365.527 91.9008Z"
            fill="#3A86FF"
          />
          <path
            d="M394.988 112.275C399.483 115.203 398.438 120.937 393.124 120.937H233.08C228.602 120.937 227.069 114.889 231.459 112.118L394.988 112.275Z"
            fill="#3A86FF"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M393.124 116.946H233.08C230.223 116.946 229.09 113.582 231.46 112.118L256.949 96.3281H374.064L394.971 112.275C397.062 113.861 395.842 116.946 393.124 116.946Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M374.656 112.188H251.548C249.353 112.188 248.482 109.591 250.294 108.476L267.995 96.3281H359.986L376.068 108.598C377.688 109.818 376.747 112.188 374.656 112.188Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M352.024 96.3281L368.123 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M343.487 96.3281L357.669 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M335.508 96.3281L347.808 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M326.587 96.3281L336.988 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M319.183 96.3281L324.253 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M275.47 96.3281L259.371 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M284.006 96.3281L269.824 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M291.986 96.3281L279.686 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M300.906 96.3281L290.505 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M308.311 96.3281L303.241 112.188"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M313.329 112.38V96.3281"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M259.371 102.254H367.775"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M357.268 91.9008H269.127L270.712 80.6594C271.688 73.7403 276.654 68.0585 283.361 66.1414L304.843 61.6797H321.552L343.034 66.1414C349.759 68.0411 354.724 73.7403 355.683 80.6594L357.268 91.9008Z"
            fill="#FFCF2D"
          />
          <path
            d="M319.146 74.5246L312.787 68.0934C312.648 67.954 312.648 67.7274 312.787 67.6054C312.927 67.466 313.153 67.466 313.275 67.6054L319.112 73.5137L328.171 63.2483C328.293 63.1088 328.52 63.0914 328.659 63.2134C328.799 63.3354 328.816 63.562 328.694 63.7014L319.146 74.5246Z"
            fill="white"
          />
          <path
            d="M307.334 74.5247L297.787 63.7015C297.665 63.5621 297.665 63.3355 297.822 63.2135C297.961 63.0915 298.187 63.0915 298.309 63.2484L307.369 73.5138L313.206 67.6055C313.345 67.4661 313.554 67.4661 313.694 67.6055C313.833 67.745 313.833 67.9541 313.694 68.0935L307.334 74.5247Z"
            fill="white"
          />
          <path
            d="M313.345 78.725C312.509 78.725 311.829 78.0452 311.829 77.2087C311.829 76.3721 312.509 75.6924 313.345 75.6924C314.181 75.6924 314.861 76.3721 314.861 77.2087C314.861 78.0452 314.181 78.725 313.345 78.725ZM313.345 76.3895C312.892 76.3895 312.526 76.7555 312.526 77.2087C312.526 77.6618 312.892 78.0278 313.345 78.0278C313.798 78.0278 314.164 77.6618 314.164 77.2087C314.164 76.7555 313.798 76.3895 313.345 76.3895Z"
            fill="white"
          />
          <path
            d="M313.345 87.265C312.509 87.265 311.829 86.5853 311.829 85.7487C311.829 84.9121 312.509 84.2324 313.345 84.2324C314.181 84.2324 314.861 84.9121 314.861 85.7487C314.861 86.5853 314.181 87.265 313.345 87.265ZM313.345 84.9296C312.892 84.9296 312.526 85.2956 312.526 85.7487C312.526 86.2019 312.892 86.5679 313.345 86.5679C313.798 86.5679 314.164 86.2019 314.164 85.7487C314.164 85.2956 313.798 84.9296 313.345 84.9296Z"
            fill="white"
          />
          <path
            d="M304.739 91.5353H276.27L268.674 68.9827L297.142 60.8262L304.739 91.5353Z"
            fill="white"
            stroke="#3A86FF"
            strokeWidth="4"
            stroke-miterlimit="10"
          />
          <path
            d="M277.751 71.9106H277.211C275.835 71.9106 274.72 70.7952 274.72 69.4183V61.5929C274.72 61.0352 275.173 60.582 275.73 60.582H278.082C278.64 60.582 279.093 61.0352 279.093 61.5929V70.5512C279.11 71.3006 278.5 71.9106 277.751 71.9106Z"
            fill="white"
          />
          <path
            d="M277.751 71.9106H277.211C275.835 71.9106 274.72 70.7952 274.72 69.4183V61.5929C274.72 61.0352 275.173 60.582 275.73 60.582H278.082C278.64 60.582 279.093 61.0352 279.093 61.5929V70.5512C279.11 71.3006 278.5 71.9106 277.751 71.9106Z"
            stroke="#3A86FF"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M289.215 71.9106H289.756C291.132 71.9106 292.247 70.7952 292.247 69.4183V61.5929C292.247 61.0352 291.794 60.582 291.236 60.582H288.867C288.309 60.582 287.856 61.0352 287.856 61.5929V70.5512C287.856 71.3006 288.466 71.9106 289.215 71.9106Z"
            fill="white"
          />
          <path
            d="M282.124 72.817H280.87C279.894 72.817 279.11 72.0328 279.11 71.0568V61.6105C279.11 61.0528 279.563 60.5996 280.121 60.5996H282.473C283.03 60.5996 283.483 61.0528 283.483 61.6105V71.4576C283.483 72.207 282.874 72.817 282.124 72.817Z"
            fill="white"
          />
          <path
            d="M286.515 73.1655H285.47C284.372 73.1655 283.483 72.2766 283.483 71.1786V61.5929C283.483 61.0352 283.936 60.582 284.494 60.582H286.846C287.403 60.582 287.856 61.0352 287.856 61.5929V71.806C287.856 72.5555 287.247 73.1655 286.515 73.1655Z"
            fill="white"
          />
          <path
            d="M289.215 71.9106H289.756C291.132 71.9106 292.247 70.7952 292.247 69.4183V61.5929C292.247 61.0352 291.794 60.582 291.236 60.582H288.867C288.309 60.582 287.856 61.0352 287.856 61.5929V70.5512C287.856 71.3006 288.466 71.9106 289.215 71.9106Z"
            stroke="#3A86FF"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M282.124 72.817H280.87C279.894 72.817 279.11 72.0328 279.11 71.0568V61.6105C279.11 61.0528 279.563 60.5996 280.121 60.5996H282.473C283.03 60.5996 283.483 61.0528 283.483 61.6105V71.4576C283.483 72.207 282.874 72.817 282.124 72.817Z"
            stroke="#3A86FF"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M286.515 73.1655H285.47C284.372 73.1655 283.483 72.2766 283.483 71.1786V61.5929C283.483 61.0352 283.936 60.582 284.494 60.582H286.846C287.403 60.582 287.856 61.0352 287.856 61.5929V71.806C287.856 72.5555 287.247 73.1655 286.515 73.1655Z"
            stroke="#3A86FF"
            strokeWidth="4"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M321.569 51.4316V64.1545C321.569 66.3505 317.824 68.1457 313.207 68.1457C308.59 68.1457 304.844 66.3505 304.844 64.1545V51.4316H321.569Z"
            fill="white"
          />
          <path
            d="M321.57 51.4316C321.57 61.0348 315.419 63.8931 309.513 63.3877C309.496 63.3877 309.478 63.3877 309.461 63.3877C306.847 63.1437 304.861 60.9128 304.861 58.2985V51.4491L321.57 51.4316Z"
            fill="#3A86FF"
          />
          <path
            d="M325.454 48.1554V48.8003C325.454 50.2294 324.304 51.3797 322.876 51.3797H321.552L321.569 51.676C321.569 55.7891 318.241 59.118 314.13 59.118H312.3C308.189 59.118 304.861 55.7891 304.861 51.676L304.878 51.3797H303.554C302.125 51.3797 300.976 50.2294 300.976 48.8003V48.1554C300.976 46.7263 302.125 45.576 303.554 45.576H305.244L305.436 42.4214C305.436 41.9334 305.505 41.4628 305.645 41.0271C310.628 42.2646 316.464 39.0577 318.032 38.0991C319.775 38.7614 321.012 40.4346 321.012 42.404L321.203 45.5586H322.893C324.304 45.576 325.454 46.7263 325.454 48.1554Z"
            fill="white"
          />
          <path
            d="M322.998 45.5759H321.186L320.994 42.4213C320.994 40.4519 319.757 38.7787 318.015 38.1164C316.447 39.0576 310.61 42.2644 305.627 41.0444C305.488 41.4802 305.418 41.9507 305.418 42.4387L305.226 45.5933H304.094C304.094 45.5933 301.777 34.3693 304.059 32.3127C305.749 30.7964 321.22 34.1079 322.928 36.4607C323.886 37.8027 322.998 45.5759 322.998 45.5759Z"
            fill="#E57281"
          />
          <path
            d="M318.643 44.896C318.59 44.896 318.521 44.8786 318.468 44.8263C318.451 44.8089 317.318 43.8852 315.506 43.8852C315.367 43.8852 315.245 43.7632 315.245 43.6237C315.245 43.4843 315.367 43.3623 315.506 43.3623C317.51 43.3623 318.747 44.3732 318.799 44.4254C318.904 44.5126 318.921 44.6869 318.834 44.7914C318.799 44.8612 318.712 44.896 318.643 44.896Z"
            fill="#3A86FF"
          />
          <path
            d="M312.022 50.2988C311.987 50.2988 311.952 50.2988 311.935 50.2814C311.795 50.2291 311.726 50.0722 311.778 49.9502C312.266 48.6605 312.144 47.0397 311.464 45.6105C311.064 44.7391 310.489 44.1117 309.983 43.9374C308.868 43.5539 307.3 44.0942 307.283 44.0942C307.144 44.1465 307.004 44.0768 306.952 43.9374C306.9 43.7979 306.969 43.6585 307.109 43.6062C307.178 43.5888 308.851 43.0137 310.14 43.4494C310.785 43.6759 311.447 44.3905 311.917 45.4014C312.649 46.9525 312.771 48.7302 312.248 50.1594C312.231 50.2291 312.126 50.2988 312.022 50.2988Z"
            fill="#3A86FF"
          />
          <path
            d="M315.454 53.0697C315.471 53.2092 315.349 53.3312 315.21 53.3486H315.193C315.053 53.3486 314.949 53.244 314.931 53.1046C314.914 52.9303 314.879 52.756 314.827 52.5992C314.078 52.9652 313.398 53.0872 312.841 53.0872C311.743 53.0872 311.081 52.634 311.046 52.5992C310.924 52.512 310.907 52.3552 310.976 52.2332C311.063 52.1112 311.22 52.0937 311.342 52.1635C311.377 52.1809 311.935 52.5643 312.841 52.5643C313.328 52.5643 313.921 52.4597 314.6 52.1286C314.496 51.9543 314.391 51.8497 314.391 51.8497C314.287 51.7452 314.304 51.5709 314.409 51.4837C314.513 51.3966 314.687 51.3966 314.774 51.5012C314.809 51.5535 315.402 52.2157 315.454 53.0697Z"
            fill="#3A86FF"
          />
          <path
            d="M316.407 48.0855C316.647 48.0705 316.818 47.669 316.788 47.1886C316.758 46.7082 316.539 46.331 316.299 46.3459C316.059 46.3609 315.889 46.7625 315.918 47.2428C315.948 47.7232 316.167 48.1005 316.407 48.0855Z"
            fill="#3A86FF"
          />
          <path
            d="M309.295 48.0159C309.515 48.0021 309.672 47.6327 309.645 47.1907C309.617 46.7488 309.416 46.4017 309.195 46.4155C308.974 46.4293 308.817 46.7987 308.845 47.2406C308.872 47.6826 309.074 48.0296 309.295 48.0159Z"
            fill="#3A86FF"
          />
          <path
            d="M304.408 48.9917C304.268 48.9917 304.146 48.8697 304.146 48.7303C304.146 47.9634 303.519 47.3534 302.77 47.3534C302.631 47.3534 302.509 47.2314 302.509 47.092C302.509 46.9526 302.631 46.8306 302.77 46.8306C303.815 46.8306 304.669 47.6846 304.669 48.7303C304.669 48.8871 304.547 48.9917 304.408 48.9917Z"
            fill="#3A86FF"
          />
          <path
            d="M321.935 48.9917C321.796 48.9917 321.674 48.8697 321.674 48.7303C321.674 47.6846 322.528 46.8306 323.573 46.8306C323.712 46.8306 323.834 46.9526 323.834 47.092C323.834 47.2314 323.712 47.3534 323.573 47.3534C322.806 47.3534 322.197 47.9809 322.197 48.7303C322.197 48.8871 322.092 48.9917 321.935 48.9917Z"
            fill="#3A86FF"
          />
          <path
            d="M637.32 434.843L562.699 188.019C561.218 183.104 556.67 179.741 551.531 179.741H98.6297C93.4378 179.741 88.873 183.174 87.427 188.176L16.2207 434.843"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M222.696 96.3276H420.792"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M291.445 133.834H338.242V174.042H291.445C291.445 174.042 291.445 132.318 291.445 133.834Z"
            fill="#FFCF2D"
          />
          <path
            d="M466.438 320.651L444.677 266.448H479.714L466.438 320.651Z"
            fill="#9A3B82"
          />
          <path
            d="M406.73 194.102C411.4 185.266 420.581 179.741 430.565 179.741H457.517L475.829 194.102H406.73Z"
            fill="#9A3B82"
          />
          <path
            d="M508.914 257.56H441.018L466.577 319.623C464.8 316.73 454.155 319.745 442.882 326.664C431.749 333.496 424.223 341.723 425.756 344.72L370.666 248.828C356.379 224.637 373.802 194.103 401.887 194.103H554.039L554.37 195.148C564.301 225.997 541.303 257.56 508.914 257.56Z"
            fill="#06D6A0"
          />
          <path
            d="M556.67 211.897C556.426 217.562 555.171 223.034 553.046 228.106L473.25 194.12H552.453L554.3 199.523C555.589 202.765 556.304 207.314 556.67 211.897Z"
            fill="#E6E6E6"
          />
          <path
            d="M466.595 319.623C468.372 322.516 460.601 330.412 449.346 337.331C438.074 344.25 427.603 347.718 425.826 344.825C424.049 341.932 431.627 333.758 442.9 326.839C454.155 319.92 464.8 316.73 466.595 319.623Z"
            fill="#3A86FF"
          />
          <path
            d="M441.593 326.873L392.043 239.242C388.158 232.306 393.158 223.731 401.12 223.731H497.624C510.622 223.731 520.326 211.758 517.643 199.035"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M425.251 345.016C423.474 342.123 431.157 332.921 442.9 326.072C456.089 318.386 464.626 316.102 467.17 320.181"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M467.553 320.564L435.182 243.355"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M399.988 193.527H478.965"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M444.659 348.816L439.955 342.402L433.474 333.583C436.122 331.353 439.31 329.035 442.882 326.839C449.99 322.481 456.837 319.588 461.385 318.787L464.538 325.078L468.476 332.921C465.688 342.838 444.659 348.816 444.659 348.816Z"
            fill="#E57281"
          />
          <path
            d="M464.556 325.078C461.629 328.651 456.123 333.165 449.346 337.331C446.088 339.335 442.899 341.043 439.972 342.402L433.491 333.583C436.139 331.353 439.328 329.035 442.899 326.839C450.008 322.481 456.855 319.588 461.402 318.787L464.556 325.078Z"
            fill="#9A3B82"
          />
          <path
            d="M490.011 367.482L442.203 401.834C438.144 404.657 431.837 407.01 432.673 396.797C433.84 382.715 436.959 361.766 444.66 348.799C444.991 348.712 465.689 342.734 468.477 332.904L490.272 348.398C496.544 353.278 496.405 362.794 490.011 367.482Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M442.447 353.348C446.245 354.062 467.571 346.498 470.881 334.838"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M437.308 398.296C437.308 398.296 468.512 354.934 490.708 357.374C514.873 360.005 417.551 423.585 437.308 398.296Z"
            fill="#FFCF2D"
          />
          <path
            d="M436.419 404.204C433.997 404.361 431.436 401.538 434.973 397.006C434.973 397.006 467.448 352.04 490.568 354.585C494.14 354.968 495.342 357.879 494.506 360.389"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M556.843 215.435C545.797 212.82 518.304 205.936 486.944 198.686C472.204 195.287 459.869 185.248 453.51 171.515L424.954 109.713L442.237 82.3152C447.551 73.8797 456.611 68.5117 466.559 67.9017L483.564 66.856C500.708 65.8103 514.472 76.5114 519.698 92.8769L554.282 194.102C558.08 203.583 556.843 215.435 556.843 215.435Z"
            fill="white"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M439.99 113.181C439.99 113.181 449.085 127.473 469.8 130.627"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M452.256 87.1778C451.315 86.167 449.66 86.4458 449.085 87.6833C448.44 89.0776 449.607 90.6287 451.123 90.4021C452.674 90.1756 453.318 88.3107 452.256 87.1778Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M495.656 116.963C494.715 115.952 493.06 116.231 492.485 117.468C491.84 118.863 493.008 120.414 494.523 120.187C496.074 119.961 496.719 118.096 495.656 116.963Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M509.402 129.163C508.461 128.152 506.806 128.431 506.231 129.669C505.586 131.063 506.754 132.614 508.27 132.387C509.803 132.178 510.447 130.313 509.402 129.163Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M535.762 198.198C534.822 197.187 533.166 197.466 532.591 198.703C531.947 200.098 533.114 201.649 534.63 201.422C536.163 201.196 536.808 199.348 535.762 198.198Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M521.006 165.206C520.065 164.195 518.41 164.474 517.835 165.711C517.19 167.105 518.357 168.657 519.873 168.43C521.424 168.203 522.068 166.339 521.006 165.206Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M527.121 141.468C525.762 141.642 525.013 143.158 525.692 144.343C526.459 145.685 528.393 145.633 529.09 144.256C529.804 142.862 528.654 141.259 527.121 141.468Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M538.254 176.674C536.895 176.848 536.146 178.364 536.825 179.549C537.592 180.891 539.526 180.839 540.222 179.462C540.937 178.068 539.804 176.465 538.254 176.674Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M492.084 138.697C491.143 137.686 489.488 137.965 488.913 139.202C488.268 140.597 489.435 142.148 490.951 141.921C492.484 141.695 493.129 139.847 492.084 138.697Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M482.484 158.443C481.543 157.433 479.888 157.711 479.313 158.949C478.668 160.343 479.836 161.894 481.352 161.668C482.902 161.441 483.547 159.576 482.484 158.443Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M465.305 151.541C466.315 150.6 466.037 148.944 464.8 148.369C463.406 147.724 461.855 148.892 462.082 150.408C462.308 151.942 464.155 152.587 465.305 151.541Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M480.55 185.527C481.561 184.586 481.282 182.93 480.045 182.355C478.651 181.71 477.1 182.878 477.327 184.394C477.553 185.945 479.418 186.59 480.55 185.527Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M506.213 156.369C507.224 155.428 506.945 153.773 505.708 153.197C504.314 152.553 502.763 153.72 502.99 155.237C503.216 156.77 505.081 157.433 506.213 156.369Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M514.977 192.865C515.987 191.923 515.709 190.268 514.472 189.693C513.078 189.048 511.527 190.215 511.754 191.732C511.963 193.283 513.827 193.928 514.977 192.865Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M462.43 118.95C461.489 117.939 459.834 118.218 459.259 119.456C458.615 120.85 459.782 122.401 461.298 122.175C462.848 121.948 463.493 120.083 462.43 118.95Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M465.55 73.7403C464.609 72.7295 462.953 73.0083 462.379 74.2458C461.734 75.6401 462.901 77.1912 464.417 76.9646C465.968 76.7381 466.612 74.8732 465.55 73.7403Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M495.656 73.7403C494.715 72.7295 493.06 73.0083 492.485 74.2458C491.84 75.6401 493.008 77.1912 494.523 76.9646C496.074 76.7381 496.719 74.8732 495.656 73.7403Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M495.708 93.2604C494.436 93.7658 494.07 95.4041 495.028 96.3975C496.091 97.4955 497.955 96.9901 498.304 95.4912C498.652 93.9749 497.154 92.6852 495.708 93.2604Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M478.599 82.141C477.275 82.5245 476.769 84.1105 477.606 85.191C478.564 86.3936 480.463 86.0625 480.951 84.6159C481.456 83.1345 480.08 81.7053 478.599 82.141Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M476.072 130.418C474.713 130.575 473.947 132.074 474.609 133.276C475.358 134.619 477.292 134.601 478.006 133.242C478.738 131.865 477.623 130.244 476.072 130.418Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M461.141 166.722C459.782 166.879 459.015 168.378 459.677 169.58C460.426 170.922 462.36 170.905 463.075 169.545C463.806 168.168 462.691 166.548 461.141 166.722Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M466.159 96.5368C464.835 96.9202 464.33 98.5062 465.166 99.5868C466.125 100.789 468.024 100.458 468.511 99.0116C469.017 97.5476 467.658 96.1185 466.159 96.5368Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M480.585 106.297C479.261 106.68 478.756 108.266 479.592 109.347C480.55 110.549 482.449 110.218 482.937 108.772C483.442 107.29 482.083 105.861 480.585 106.297Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M449.346 105.879C450.217 104.816 449.747 103.212 448.423 102.811C446.959 102.358 445.565 103.718 446.001 105.182C446.437 106.68 448.353 107.081 449.346 105.879Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M515.395 105.931C516.266 104.868 515.796 103.264 514.472 102.864C513.008 102.41 511.614 103.77 512.05 105.234C512.468 106.733 514.402 107.134 515.395 105.931Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M498.635 176.586C499.506 175.523 499.036 173.92 497.712 173.519C496.248 173.066 494.854 174.425 495.29 175.889C495.708 177.371 497.642 177.771 498.635 176.586Z"
            fill="#FFCF2D"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M484.732 66.2809C484.348 66.2983 483.965 66.3157 483.564 66.3332L466.56 67.3789C462.222 67.6403 458.075 68.808 454.312 70.7426L449.085 55.0917L472.379 38.0117L484.732 66.2809Z"
            fill="#E57281"
          />
          <path
            d="M454.242 70.4984C459.086 68.3024 462.953 64.3984 465.149 59.5533L473.616 40.8176L472.379 37.9941L449.085 55.0742L454.242 70.4984Z"
            fill="#9A3B82"
          />
          <path
            d="M473.877 39.5805C473.877 41.2014 473.215 42.6654 472.152 43.7285C471.09 44.7917 469.626 45.454 468.006 45.454H462.883C460.862 53.3143 453.04 58.6997 444.625 57.2183L440.774 56.5386C436.558 55.7891 433.683 51.8503 434.276 47.6151L438.788 25.0103C439.572 20.1825 444.537 17.2371 449.154 18.8928L456.629 21.8905C460.671 23.2848 463.389 27.0843 463.389 31.3543V33.5328L468.006 33.7071C471.246 33.7071 473.877 36.3388 473.877 39.5805Z"
            fill="#E57281"
          />
          <path
            d="M465.201 40.7132C465.201 38.4649 467.013 36.6523 469.261 36.6523"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M441.297 29.7681C441.297 29.7681 444.956 29.7681 447.569 33.2712"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M443.723 36.2903C443.907 35.2769 443.673 34.3856 443.2 34.2996C442.726 34.2135 442.193 34.9653 442.009 35.9787C441.825 36.992 442.06 37.8832 442.533 37.9693C443.006 38.0553 443.539 37.3036 443.723 36.2903Z"
            fill="#9A3B82"
          />
          <path
            d="M468.006 33.7069C471.246 33.7069 473.877 36.3386 473.877 39.5804C473.877 39.5978 473.877 39.6326 473.877 39.6675C476.491 35.6415 482.902 25.3935 482.902 21.9252C482.902 17.2718 477.1 12.6183 471.09 14.7446C471.49 14.4483 471.908 14.1346 472.344 13.8035C474.661 11.9909 475.881 10.6315 476.072 9.65547C476.142 9.3069 476.09 8.99318 475.916 8.74918C475.219 7.75575 474.452 7.32004 473.633 7.45947C472.431 7.65118 471.194 9.13261 469.957 11.8515C469.4 13.0889 468.964 14.3089 468.72 15.0583C468.232 12.1478 465.88 2.50975 455.775 3.99118C452.291 4.49661 450.653 5.94318 450.2 7.52918C447.308 5.26347 443.44 3.48575 440.234 5.17632C434.694 8.0869 435.373 12.8623 438.579 16.2435C435.547 16.1912 433.422 17.08 433.422 19.642C433.422 21.9949 435.844 23.1278 439.171 23.5809C442.499 24.0341 446.768 23.7901 450.461 23.3718C453.092 23.0755 455.461 22.7095 456.977 22.4481C455.967 24.5221 455.566 26.2998 455.653 27.7986C455.81 30.9009 458.057 32.7309 461.228 33.3758C461.908 33.5152 462.64 33.6023 463.389 33.6372L468.006 33.7069ZM473.738 8.15661C473.79 8.13918 473.842 8.13918 473.912 8.13918C474.4 8.13918 474.87 8.48775 475.341 9.15004C475.376 9.21976 475.428 9.32433 475.393 9.51604C475.114 10.9278 471.543 13.6118 469.469 15.0235C470.288 12.6183 472.013 8.4529 473.738 8.15661Z"
            fill="#FFCF2D"
          />
          <path
            d="M454.102 13.3156C452.9 13.3156 451.68 12.6707 450.792 11.5378C449.799 10.283 449.468 8.73184 449.886 7.38984C449.938 7.21555 450.112 7.11098 450.287 7.14584C450.356 7.14584 450.426 7.16327 450.478 7.21555C453.109 9.09784 455.217 11.7818 454.904 12.845C454.834 13.1238 454.608 13.2981 454.311 13.3156C454.242 13.3156 454.172 13.3156 454.102 13.3156ZM450.443 8.05213C450.287 9.06298 450.6 10.1784 451.332 11.1021C452.116 12.0956 453.196 12.6707 454.242 12.601C454.276 12.1478 453.109 10.0738 450.443 8.05213Z"
            fill="white"
          />
          <path
            d="M419.71 167.21H308.205C305.452 167.21 303.797 164.177 305.261 161.859L320.105 138.54C322.039 135.507 325.366 133.677 328.955 133.677H404.43L419.71 167.21Z"
            fill="#E57281"
          />
          <path
            d="M331.412 133.695L340.298 119.055C340.82 118.183 341.779 117.643 342.789 117.643C345.071 117.643 346.465 120.135 345.281 122.087L338.224 133.695H331.412Z"
            fill="#FE5244"
          />
          <path
            d="M419.71 167.21H394.639C394.586 167.158 394.517 167.088 394.464 167.036C388.366 160.761 385.77 151.245 389.203 142.078L392.774 133.677H404.43L419.71 167.21Z"
            fill="#9A3B82"
          />
          <path
            d="M323.955 151.559H309.982C309.042 151.559 308.171 152.065 307.7 152.884L306.219 155.463C305.226 157.206 306.481 159.385 308.502 159.385H319.739C321.69 159.385 323.502 158.374 324.53 156.701L325.733 154.731C326.569 153.337 325.576 151.559 323.955 151.559Z"
            fill="#E57281"
          />
          <path
            d="M320.349 159.384H306.376C305.435 159.384 304.564 159.89 304.094 160.709L302.613 163.288C301.62 165.031 302.874 167.21 304.895 167.21H316.133C318.084 167.21 319.896 166.199 320.924 164.526L322.126 162.556C322.98 161.162 321.969 159.384 320.349 159.384Z"
            fill="#E57281"
          />
          <path
            d="M327.946 143.629H313.973C313.032 143.629 312.161 144.134 311.69 144.953L310.209 147.533C309.216 149.276 310.471 151.454 312.492 151.454H323.729C325.681 151.454 327.493 150.443 328.521 148.77L329.723 146.801C330.576 145.407 329.566 143.629 327.946 143.629Z"
            fill="#E57281"
          />
          <path
            d="M323.955 151.559H309.982C309.042 151.559 308.171 152.065 307.7 152.884L306.219 155.463C305.226 157.206 306.481 159.385 308.502 159.385H319.739C321.69 159.385 323.502 158.374 324.53 156.701L325.733 154.731C326.569 153.337 325.576 151.559 323.955 151.559Z"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M320.349 159.384H306.376C305.435 159.384 304.564 159.89 304.094 160.709L302.613 163.288C301.62 165.031 302.874 167.21 304.895 167.21H316.133C318.084 167.21 319.896 166.199 320.924 164.526L322.126 162.556C322.98 161.162 321.969 159.384 320.349 159.384Z"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M327.946 143.629H313.973C313.032 143.629 312.161 144.134 311.69 144.953L310.209 147.533C309.216 149.276 310.471 151.454 312.492 151.454H323.729C325.681 151.454 327.493 150.443 328.521 148.77L329.723 146.801C330.576 145.407 329.566 143.629 327.946 143.629Z"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M348.173 155.289C343.974 155.289 339.932 153.773 336.761 151.001L331.464 146.365H326.586L325.332 147.707C323.084 150.113 320.314 151.489 317.021 151.489H314.686C313.467 151.489 312.718 150.13 313.38 149.102L319.251 139.899H348.19V155.289H348.173Z"
            fill="#E57281"
          />
          <path
            d="M319.251 139.899L313.38 149.102C312.718 150.13 313.467 151.489 314.686 151.489H317.021C320.314 151.489 323.084 150.13 325.332 147.707L326.586 146.365H331.464L336.761 151.001C339.914 153.755 343.974 155.289 348.173 155.289"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M465.811 134.618L439.206 164.352C433.614 170.608 425.617 174.181 417.219 174.181C400.633 174.181 389.151 157.624 394.97 142.078L426.575 67.7972L415.895 61.8192C414.379 60.6341 413.647 58.6995 413.978 56.8172L415.79 44.5998C416.348 41.8809 419.118 39.7546 421.819 39.1272L434.328 36.3038C435.391 36.0598 436.367 36.9661 436.192 38.0292L434.38 47.4581C433.666 52.0592 436.767 56.0329 441.367 56.8172C445.13 57.4621 447.778 61.2441 447.43 65.0435L438.91 118.201C438.893 118.236 447.622 131.847 465.811 134.618Z"
            fill="#E57281"
          />
          <path
            d="M445.409 77.6792L435.13 144.448"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M424.101 45.4888L423.962 49.8111C423.91 51.5888 424.972 53.1573 426.506 53.5931L442.517 56.8348"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M453.406 58.2291L440.6 56.5211C436.384 55.7717 433.509 51.8328 434.101 47.5977L435.757 38.1339C435.913 37.2451 435.112 36.4957 434.241 36.7048L421.174 39.7548"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M446.332 156.334L480.968 117.782"
            stroke="#FE5244"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M426.94 67.8145H433.056"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M424.118 46.6388V48.0331C424.118 49.6888 425.32 51.0482 426.801 51.0482H428.718C429.554 51.0482 430.216 50.2988 430.216 49.3576L430.338 40.2599C430.355 38.8482 428.857 37.9768 427.638 38.2731"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M430.338 46.6387V48.033C430.338 49.6887 431.54 51.0481 433.021 51.0481H434.241"
            stroke="#9A3B82"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M546.042 266.448L566.27 434.843"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M458.371 266.448L438.144 434.843"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M445.078 377.015H559.318"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M446.716 266.971H556.652C558.116 266.971 559.301 265.786 559.301 264.322V260.732C559.301 259.268 558.116 258.083 556.652 258.083H446.716C445.252 258.083 444.067 259.268 444.067 260.732V264.322C444.067 265.786 445.252 266.971 446.716 266.971Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M263.778 139.533L246.947 174.181H196.091L216.528 139.533H263.778Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M252.627 147.986C252.627 147.986 250.414 144.204 245.1 145.18C241.128 145.895 236.424 149.171 233.532 147.411C230.639 145.651 228.078 143.455 224.332 144.501C220.587 145.546 217.816 147.551 217.816 147.551"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M250.885 153.389C250.885 153.389 248.672 149.607 243.358 150.583C239.386 151.298 234.682 154.574 231.789 152.814C228.897 151.054 226.336 148.858 222.59 149.903C218.844 150.949 216.074 152.953 216.074 152.953"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M282.908 295.031C282.908 299.684 269.998 303.449 253.83 303.449C237.662 303.449 225.135 299.684 225.135 295.031C225.135 290.377 237.662 286.613 253.83 286.613C269.998 286.613 282.908 290.395 282.908 295.031Z"
            fill="#FE5244"
          />
          <path
            d="M275.469 289.367V349.495L273.64 340.816C271.671 331.474 263.43 324.799 253.882 324.799C251.008 324.799 248.185 325.409 245.624 326.559C245.537 326.594 245.45 326.646 245.345 326.681L238.638 302.211L234.909 288.6C240.014 287.362 246.617 286.613 253.83 286.613C262.402 286.613 270.12 287.676 275.469 289.367Z"
            fill="#A0505A"
          />
          <path
            d="M275.469 289.366V300.695C270.12 302.386 262.402 303.449 253.83 303.449C248.272 303.449 243.08 302.996 238.638 302.229L234.909 288.617C240.014 287.38 246.617 286.63 253.83 286.63C262.402 286.613 270.12 287.676 275.469 289.366Z"
            fill="#73325A"
          />
          <path
            d="M274.18 347.735C274.65 347.874 279.075 349.111 282.996 349.111C285.121 349.111 287.09 348.745 288.205 347.63C289.163 346.671 289.39 345.277 288.884 343.517C288.431 341.948 287.56 340.972 286.288 340.624C283.954 339.996 280.713 341.739 278.152 343.569C282.142 338.724 286.079 332.572 284.616 328.546C284.093 327.117 282.908 326.158 281.427 325.984C280.19 325.844 279.041 326.28 278.5 327.099C275.992 330.916 273.936 346.584 273.849 347.247L274.18 347.735ZM279.232 327.587C279.546 327.117 280.208 326.838 280.974 326.838C281.096 326.838 281.218 326.838 281.34 326.855C281.898 326.925 283.239 327.239 283.814 328.842C284.198 329.905 284.337 331.857 282.786 335.134C281.323 338.236 278.675 341.879 274.911 346.009C275.469 342.035 277.246 330.602 279.232 327.587ZM287.595 347.02C286.445 348.17 283.832 348.519 280.016 348.031C278.013 347.769 276.148 347.351 275.155 347.09C275.905 346.427 277.298 345.225 278.919 344.109C282.02 341.966 284.494 341.042 286.079 341.478C287.038 341.739 287.682 342.489 288.065 343.761C288.484 345.225 288.327 346.288 287.595 347.02Z"
            fill="#FFCF2D"
          />
          <path
            d="M238.812 331.561L234.787 336.075C230.222 341.199 229.473 348.658 232.94 354.584L250.659 384.979C254.126 390.923 260.486 394.565 267.35 394.565H274.685C279.999 394.565 283.954 389.685 282.856 384.491L273.622 340.833C271.654 331.491 263.413 324.816 253.865 324.816C248.133 324.799 242.645 327.256 238.812 331.561Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M252.524 344.702L275.4 389.04C276.48 391.045 277.821 392.334 279.354 393.153C278.03 394.042 276.427 394.583 274.685 394.583H267.35C260.468 394.583 254.109 390.923 250.659 384.997L232.941 354.584C232.226 353.346 231.686 352.057 231.32 350.715C228.811 341.39 239.422 334.07 247.384 339.543C249.196 340.78 250.973 342.454 252.524 344.702Z"
            fill="#06D6A0"
          />
          <path
            d="M252.575 344.806H231.459C231.564 344.475 231.685 344.162 231.825 343.865H251.896C252.105 344.144 252.314 344.423 252.523 344.719L252.575 344.806Z"
            fill="white"
          />
          <path
            d="M255.677 350.802H231.355C231.355 350.767 231.337 350.732 231.337 350.715C231.267 350.436 231.198 350.14 231.146 349.861H255.206L255.677 350.802Z"
            fill="white"
          />
          <path
            d="M258.778 356.815H234.247L233.689 355.856H258.29L258.778 356.815Z"
            fill="white"
          />
          <path
            d="M261.879 362.828H237.749L237.191 361.869H261.391L261.879 362.828Z"
            fill="white"
          />
          <path
            d="M264.981 368.823H241.251L240.693 367.882H264.493L264.981 368.823Z"
            fill="white"
          />
          <path
            d="M268.082 374.836H244.753L244.195 373.877H267.576L268.082 374.836Z"
            fill="white"
          />
          <path
            d="M271.183 380.849H248.255L247.697 379.89H270.678L271.183 380.849Z"
            fill="white"
          />
          <path
            d="M274.266 386.844H251.895C251.669 386.53 251.442 386.217 251.233 385.903H273.778L274.266 386.844Z"
            fill="white"
          />
          <path
            d="M278.848 392.857H259.405C258.777 392.578 258.168 392.265 257.575 391.916H277.594C277.995 392.265 278.413 392.578 278.848 392.857Z"
            fill="white"
          />
          <path
            d="M211.545 293.794C211.388 298.395 198.339 302.124 182.275 302.124C166.211 302.124 153.162 298.412 153.005 293.794V257.56H211.545V293.794Z"
            fill="#73325A"
          />
          <path
            d="M207.659 299.807L207.572 304.112L206.736 346.132V344.912C206.736 334.124 197.99 325.374 187.205 325.374H186.02C180.515 325.374 175.549 327.518 171.873 330.969L169.312 313.645L167.727 302.926C172.013 303.641 176.978 304.042 182.257 304.042C193.129 304.024 202.589 302.316 207.659 299.807Z"
            fill="#A0505A"
          />
          <path
            d="M207.659 299.807L207.572 304.112C201.091 308.713 181.072 314.377 169.33 313.628L167.744 302.909C172.03 303.606 176.996 304.024 182.275 304.024C193.129 304.024 202.589 302.316 207.659 299.807Z"
            fill="#73325A"
          />
          <path
            d="M188.094 395.141H191.335C199.837 395.141 206.736 388.239 206.736 379.734V344.911C206.736 334.123 197.99 325.374 187.205 325.374H186.021C173.476 325.374 163.807 336.441 165.497 348.885L169.591 379.002C170.863 388.239 178.756 395.141 188.094 395.141Z"
            fill="white"
            stroke="#06D6A0"
            strokeWidth="5"
            stroke-miterlimit="10"
          />
          <path
            d="M201.893 390.94C199.14 393.537 195.411 395.141 191.335 395.141H188.094C178.755 395.141 170.863 388.239 169.609 379.002L165.514 348.885C165.445 348.31 165.375 347.735 165.357 347.177C166.403 340.502 172.17 335.396 179.139 335.396C182.571 335.396 185.742 336.65 188.198 338.742C190.655 340.833 192.38 343.779 192.92 347.177L198.304 383.934C198.704 386.67 199.994 389.11 201.893 390.94Z"
            fill="#06D6A0"
          />
          <path
            d="M191.3 342.524H166.961C167.135 342.193 167.344 341.879 167.553 341.583H190.725C190.934 341.879 191.126 342.193 191.3 342.524Z"
            fill="white"
          />
          <path
            d="M193.112 348.519H165.462C165.427 348.206 165.392 347.892 165.375 347.578H192.972L193.112 348.519Z"
            fill="white"
          />
          <path
            d="M194 354.532H166.281L166.142 353.591H193.861L194 354.532Z"
            fill="white"
          />
          <path
            d="M194.872 360.545H167.1L166.961 359.586H194.733L194.872 360.545Z"
            fill="white"
          />
          <path
            d="M195.76 366.54H167.919L167.779 365.599H195.621L195.76 366.54Z"
            fill="white"
          />
          <path
            d="M196.632 372.553H168.721L168.599 371.612H196.492L196.632 372.553Z"
            fill="white"
          />
          <path
            d="M197.52 378.566H169.539L169.417 377.607H197.38L197.52 378.566Z"
            fill="white"
          />
          <path
            d="M198.408 384.561H171.264C171.107 384.248 170.968 383.934 170.846 383.62H198.252L198.304 383.934C198.339 384.143 198.373 384.352 198.408 384.561Z"
            fill="white"
          />
          <path
            d="M201.527 390.574H175.863C175.515 390.278 175.166 389.947 174.853 389.633H200.725C200.969 389.964 201.248 390.278 201.527 390.574Z"
            fill="white"
          />
          <path
            d="M224.212 105.46V134.81C222.94 131.481 212.869 131.952 201.789 136.152C192.293 139.76 185.167 144.71 184.122 148.143V106.837C184.122 94.5501 190.69 83.5701 200.778 77.5747C213.88 79.8579 224.212 91.2736 224.212 105.46Z"
            fill="#FFCF2D"
          />
          <path
            d="M183.356 78.8994C174.435 85.104 168.756 95.4043 168.756 106.837V140.91H119.153L126 111.421C128.91 98.8551 138.005 88.8337 149.852 84.5637L183.356 78.8994Z"
            fill="#FFCF2D"
          />
          <path
            d="M283.675 224.742V293.149C283.675 288.495 269.998 284.731 253.83 284.731C237.662 284.731 224.56 288.495 224.56 293.149V260.366C224.56 258.832 223.305 257.577 221.772 257.577H132.847C106.103 257.577 86.3287 232.672 92.3743 206.616L113.839 114.105C117.254 99.343 129.206 88.1016 144.137 85.557L149.852 84.581C138.004 88.851 128.91 98.8724 126 111.438L119.153 140.928H168.755V106.837C168.755 95.4041 174.452 85.0864 183.355 78.8993L191.195 77.5747C192.816 77.2958 194.401 77.1738 195.987 77.1738C196.196 77.1738 196.387 77.1738 196.596 77.1738C196.788 77.1738 196.98 77.1913 197.154 77.1913C197.189 77.1913 197.224 77.1913 197.258 77.1913C197.398 77.1913 197.555 77.2087 197.694 77.2087C197.711 77.2087 197.746 77.2087 197.764 77.2087C197.851 77.2087 197.938 77.2261 198.008 77.2261C198.164 77.2435 198.304 77.2435 198.461 77.261C198.635 77.2784 198.827 77.2958 199.001 77.3133C199.175 77.3307 199.332 77.3481 199.506 77.3655C199.541 77.3655 199.576 77.383 199.628 77.383C199.802 77.4004 199.994 77.4353 200.168 77.4527C200.186 77.4527 200.203 77.4527 200.203 77.4527C200.395 77.4875 200.586 77.505 200.778 77.5398C190.69 83.5353 184.122 94.5153 184.122 106.802V190.547H249.526C268.378 190.582 283.675 205.866 283.675 224.742Z"
            fill="#FE5244"
          />
          <path
            d="M184.488 78.1323C175.568 84.3369 168.738 95.4041 168.738 106.837V140.91H119.136L125.983 111.421C128.892 98.8549 137.22 88.6418 149.085 84.3718"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M224.56 249.856C224.56 240.148 227.992 230.754 234.247 223.347"
            stroke="white"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M152.1 246.388C152.012 246.388 151.925 246.371 151.856 246.318L149.556 245.064C149.295 244.924 149.207 244.61 149.347 244.349C149.486 244.088 149.8 244 150.061 244.14L152.361 245.395C152.622 245.534 152.709 245.848 152.57 246.109C152.465 246.284 152.291 246.388 152.1 246.388ZM154.399 245.796C154.208 245.796 154.033 245.691 153.946 245.517C153.807 245.255 153.894 244.942 154.155 244.802L156.455 243.547C156.717 243.408 157.03 243.512 157.17 243.756C157.309 244.018 157.222 244.332 156.96 244.471L154.661 245.726C154.574 245.761 154.486 245.796 154.399 245.796ZM147.5 243.896C147.413 243.896 147.326 243.878 147.256 243.826L144.956 242.571C144.695 242.432 144.608 242.118 144.747 241.857C144.887 241.595 145.2 241.508 145.462 241.648L147.761 242.902C148.023 243.042 148.11 243.356 147.97 243.617C147.866 243.791 147.692 243.896 147.5 243.896ZM158.981 243.286C158.79 243.286 158.616 243.181 158.528 243.007C158.389 242.746 158.476 242.432 158.738 242.292L161.037 241.038C161.438 240.828 161.804 240.584 162.17 240.323C162.396 240.149 162.727 240.201 162.902 240.428C163.076 240.654 163.024 240.985 162.797 241.16C162.396 241.456 161.978 241.717 161.543 241.961L159.243 243.216C159.156 243.268 159.069 243.286 158.981 243.286ZM142.953 241.316C142.848 241.316 142.744 241.282 142.639 241.212C141.907 240.672 141.228 240.044 140.653 239.33C140.461 239.103 140.496 238.772 140.723 238.598C140.949 238.406 141.28 238.441 141.454 238.667C141.977 239.312 142.587 239.87 143.249 240.358C143.475 240.532 143.528 240.863 143.371 241.09C143.284 241.247 143.127 241.316 142.953 241.316ZM164.365 239.486C164.243 239.486 164.139 239.452 164.034 239.364C163.808 239.19 163.773 238.859 163.964 238.632C164.487 237.988 164.923 237.29 165.271 236.524C165.393 236.262 165.707 236.14 165.968 236.262C166.229 236.384 166.351 236.698 166.229 236.959C165.846 237.796 165.358 238.58 164.783 239.277C164.661 239.417 164.522 239.486 164.365 239.486ZM139.677 237.325C139.486 237.325 139.294 237.221 139.207 237.029C138.824 236.192 138.545 235.321 138.371 234.415C138.318 234.136 138.51 233.857 138.789 233.805C139.067 233.752 139.346 233.944 139.398 234.223C139.555 235.042 139.799 235.826 140.148 236.576C140.27 236.837 140.148 237.151 139.886 237.273C139.817 237.308 139.747 237.325 139.677 237.325ZM166.525 234.781C166.491 234.781 166.456 234.781 166.438 234.781C166.16 234.728 165.968 234.45 166.02 234.171C166.125 233.596 166.177 233.02 166.177 232.445V231.661C166.177 231.365 166.404 231.138 166.7 231.138C166.996 231.138 167.222 231.365 167.222 231.661V232.445C167.222 233.09 167.17 233.735 167.048 234.362C166.996 234.606 166.769 234.781 166.525 234.781ZM138.719 232.236C138.423 232.236 138.196 232.01 138.196 231.713V229.099C138.196 228.803 138.423 228.576 138.719 228.576C139.015 228.576 139.242 228.803 139.242 229.099V231.713C139.242 231.992 138.998 232.236 138.719 232.236ZM166.682 229.57C166.386 229.57 166.16 229.343 166.16 229.047V226.432C166.16 226.136 166.386 225.91 166.682 225.91C166.978 225.91 167.205 226.136 167.205 226.432V229.047C167.205 229.343 166.978 229.57 166.682 229.57ZM138.719 227.008C138.423 227.008 138.196 226.781 138.196 226.485V223.87C138.196 223.574 138.423 223.348 138.719 223.348C139.015 223.348 139.242 223.574 139.242 223.87V226.485C139.242 226.764 138.998 227.008 138.719 227.008ZM166.682 224.341C166.386 224.341 166.16 224.114 166.16 223.818V221.204C166.16 220.908 166.386 220.681 166.682 220.681C166.978 220.681 167.205 220.908 167.205 221.204V223.818C167.205 224.114 166.978 224.341 166.682 224.341ZM138.719 221.779C138.423 221.779 138.196 221.552 138.196 221.256V218.642C138.196 218.346 138.423 218.119 138.719 218.119C139.015 218.119 139.242 218.346 139.242 218.642V221.256C139.242 221.535 138.998 221.779 138.719 221.779ZM166.682 219.112C166.386 219.112 166.16 218.886 166.16 218.59V215.975C166.16 215.679 166.386 215.452 166.682 215.452C166.978 215.452 167.205 215.679 167.205 215.975V218.59C167.205 218.886 166.978 219.112 166.682 219.112ZM138.719 216.55C138.423 216.55 138.196 216.324 138.196 216.028V213.779H139.608C139.904 213.779 140.13 214.006 140.13 214.302C140.13 214.598 139.904 214.825 139.608 214.825H139.242V216.028C139.242 216.306 138.998 216.55 138.719 216.55ZM165.741 214.825H163.128C162.832 214.825 162.605 214.598 162.605 214.302C162.605 214.006 162.832 213.779 163.128 213.779H165.741C166.038 213.779 166.264 214.006 166.264 214.302C166.264 214.598 166.038 214.825 165.741 214.825ZM160.515 214.825H157.901C157.605 214.825 157.379 214.598 157.379 214.302C157.379 214.006 157.605 213.779 157.901 213.779H160.515C160.811 213.779 161.037 214.006 161.037 214.302C161.037 214.598 160.811 214.825 160.515 214.825ZM155.288 214.825H152.674C152.378 214.825 152.152 214.598 152.152 214.302C152.152 214.006 152.378 213.779 152.674 213.779H155.288C155.584 213.779 155.811 214.006 155.811 214.302C155.811 214.598 155.584 214.825 155.288 214.825ZM150.061 214.825H147.448C147.152 214.825 146.925 214.598 146.925 214.302C146.925 214.006 147.152 213.779 147.448 213.779H150.061C150.357 213.779 150.584 214.006 150.584 214.302C150.584 214.598 150.357 214.825 150.061 214.825ZM144.834 214.825H142.221C141.925 214.825 141.698 214.598 141.698 214.302C141.698 214.006 141.925 213.779 142.221 213.779H144.834C145.13 213.779 145.357 214.006 145.357 214.302C145.357 214.598 145.13 214.825 144.834 214.825Z"
            fill="white"
          />
          <path
            d="M102.793 243.495C102.601 243.495 102.427 243.39 102.34 243.216C102.201 242.955 102.288 242.641 102.549 242.502L104.675 241.334C104.727 241.299 104.779 241.282 104.831 241.247C105.075 241.107 105.406 241.194 105.546 241.438C105.685 241.682 105.598 242.014 105.354 242.153C105.302 242.188 105.249 242.223 105.18 242.24L103.054 243.408C102.967 243.478 102.88 243.495 102.793 243.495ZM107.201 240.706C107.061 240.706 106.922 240.654 106.818 240.532C106.626 240.323 106.643 239.992 106.852 239.8C107.462 239.242 108.002 238.598 108.473 237.918C108.629 237.674 108.961 237.622 109.204 237.778C109.448 237.935 109.501 238.266 109.344 238.51C108.839 239.26 108.229 239.957 107.567 240.584C107.445 240.672 107.323 240.706 107.201 240.706ZM110.11 236.419C110.041 236.419 109.988 236.402 109.919 236.384C109.657 236.28 109.518 235.983 109.623 235.704C109.919 234.92 110.128 234.118 110.25 233.299C110.285 233.02 110.546 232.811 110.842 232.846C111.121 232.881 111.33 233.142 111.295 233.439C111.173 234.345 110.947 235.234 110.616 236.088C110.511 236.297 110.319 236.419 110.11 236.419ZM110.86 231.295C110.563 231.295 110.337 231.068 110.337 230.772V228.158C110.337 227.862 110.563 227.635 110.86 227.635C111.156 227.635 111.382 227.862 111.382 228.158V230.772C111.382 231.051 111.156 231.295 110.86 231.295ZM110.86 226.066C110.563 226.066 110.337 225.84 110.337 225.544V222.929C110.337 222.633 110.563 222.406 110.86 222.406C111.156 222.406 111.382 222.633 111.382 222.929V225.544C111.382 225.822 111.156 226.066 110.86 226.066ZM110.86 220.838C110.563 220.838 110.337 220.611 110.337 220.315V217.701C110.337 217.404 110.563 217.178 110.86 217.178C111.156 217.178 111.382 217.404 111.382 217.701V220.315C111.382 220.594 111.156 220.838 110.86 220.838ZM110.86 215.609C110.563 215.609 110.337 215.383 110.337 215.086V214.825H109.03C108.734 214.825 108.508 214.598 108.508 214.302C108.508 214.006 108.734 213.779 109.03 213.779H111.382V215.086C111.382 215.365 111.156 215.609 110.86 215.609ZM106.417 214.825H103.803C103.507 214.825 103.281 214.598 103.281 214.302C103.281 214.006 103.507 213.779 103.803 213.779H106.417C106.713 213.779 106.939 214.006 106.939 214.302C106.939 214.598 106.696 214.825 106.417 214.825ZM101.19 214.825H98.5766C98.2804 214.825 98.0539 214.598 98.0539 214.302C98.0539 214.006 98.2804 213.779 98.5766 213.779H101.19C101.486 213.779 101.713 214.006 101.713 214.302C101.713 214.598 101.469 214.825 101.19 214.825ZM95.9632 214.825H93.3498C93.0536 214.825 92.8271 214.598 92.8271 214.302C92.8271 214.006 93.0536 213.779 93.3498 213.779H95.9632C96.2594 213.779 96.4859 214.006 96.4859 214.302C96.4859 214.598 96.242 214.825 95.9632 214.825Z"
            fill="white"
          />
          <path
            d="M224.212 134.811C225.484 138.139 217.434 144.048 206.371 148.248C195.308 152.448 185.394 153.093 184.122 149.747C182.85 146.401 190.708 140.37 201.789 136.17C212.87 131.97 222.94 131.464 224.212 134.811Z"
            fill="#FE5244"
          />
          <path
            d="M230.396 242.937V244.785C229.821 244.645 229.212 244.576 228.602 244.576H226.354C223.027 244.576 220.187 242.449 219.106 239.486L225.483 238.632C228.079 238.284 230.396 240.306 230.396 242.937Z"
            fill="#73325A"
          />
          <path
            d="M236.285 252.262V266.449C236.285 269.76 233.602 272.444 230.292 272.444H223.619C221.964 272.444 220.466 271.782 219.385 270.684C218.305 269.603 217.626 268.104 217.626 266.449H221.964C223.393 266.449 224.542 265.298 224.542 263.869V260.157C224.542 258.728 223.393 257.577 221.964 257.577H199.785C191.126 257.577 184.104 250.554 184.104 241.892V148.161C185.15 144.727 192.276 139.76 201.771 136.17C208.252 133.712 214.402 132.527 218.636 132.632V236.89C218.636 241.142 222.086 244.593 226.337 244.593H228.584C232.836 244.576 236.285 248.009 236.285 252.262Z"
            fill="#A0505A"
          />
          <path
            d="M218.636 132.614V142.095C215.483 144.222 211.214 146.4 206.353 148.23C195.272 152.431 185.376 153.075 184.104 149.729V148.143C185.15 144.71 192.276 139.743 201.771 136.152C208.27 133.695 214.402 132.51 218.636 132.614Z"
            fill="#73325A"
          />
          <path
            d="M189.663 62.0112L183.112 78.8995L149.347 84.9472L158.163 62.0112H189.663Z"
            fill="#A0505A"
          />
          <path
            d="M189.663 62.0112L186.126 71.1438L152.64 76.3724L158.163 62.0112H189.663Z"
            fill="#73325A"
          />
          <path
            d="M209.455 27.6417C209.455 29.9249 205.5 32.452 200.935 34.5783C194.715 37.4889 187.38 39.7023 187.38 39.7023L182.432 49.0266C189.157 52.5995 191.788 59.0132 192.833 63.4923C193.496 66.3506 193.496 68.3898 193.496 68.3898H146.071C146.071 68.3898 133.614 28.0252 163.633 18.3697C181.997 12.4614 209.455 22.2214 209.455 27.6417Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M159.242 24.1213C165.757 24.1213 171.038 18.8386 171.038 12.3221C171.038 5.80561 165.757 0.522949 159.242 0.522949C152.728 0.522949 147.447 5.80561 147.447 12.3221C147.447 18.8386 152.728 24.1213 159.242 24.1213Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M192.816 63.4925C191.84 59.2574 189.401 53.2271 183.39 49.5845H181.839C180.411 49.5845 179.104 49.0094 178.163 48.0682C177.222 47.1271 176.647 45.82 176.647 44.3908C176.647 41.5151 178.965 39.1971 181.839 39.1971L188.408 39.3365H188.582C188.704 39.3017 188.826 39.2494 188.965 39.2145C190.742 38.8311 196.37 37.4717 201.039 35.1362L201.579 38.3605L203.321 48.6957C204.506 55.7891 199.645 62.3248 192.816 63.4925Z"
            fill="#A0505A"
          />
          <path
            d="M201.562 38.3429C195.848 40.6609 188.391 39.3189 188.391 39.3189C188.391 39.3189 195.412 37.9247 201.022 35.1187L201.562 38.3429Z"
            fill="#73325A"
          />
          <path
            d="M185.881 45.3842C185.881 43.3974 184.278 41.7939 182.292 41.7939"
            stroke="#73325A"
            strokeWidth="5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M204.332 266.448L224.56 434.843"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M116.644 266.448L96.4336 434.843"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M103.367 377.015H217.607"
            stroke="#3A86FF"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
          <path
            d="M99.0642 266.448H221.911C223.375 266.448 224.559 265.263 224.559 263.799V260.209C224.559 258.745 223.375 257.56 221.911 257.56H99.0642C97.6007 257.56 96.416 258.745 96.416 260.209V263.799C96.4334 265.263 97.6182 266.448 99.0642 266.448Z"
            fill="white"
            stroke="#FFCF2D"
            strokeWidth="6"
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_362_919">
            <rect width="653" height="435" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];
